import { jsx as nt } from "react/jsx-runtime";
import le, { createContext as Yr, useRef as Pt, useContext as ur, useMemo as wt, useDebugValue as fr, useEffect as Pe, useLayoutEffect as Mn, useState as cr, useCallback as Nn } from "react";
function Y() {
  return Y = Object.assign ? Object.assign.bind() : function(r) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var e in n)
        Object.prototype.hasOwnProperty.call(n, e) && (r[e] = n[e]);
    }
    return r;
  }, Y.apply(this, arguments);
}
function Hr(r, t) {
  if (r == null)
    return {};
  var n = {}, e = Object.keys(r), i, o;
  for (o = 0; o < e.length; o++)
    i = e[o], !(t.indexOf(i) >= 0) && (n[i] = r[i]);
  return n;
}
function Ft(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var Et = { exports: {} }, U = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lr;
function Dn() {
  if (lr)
    return U;
  lr = 1;
  var r = typeof Symbol == "function" && Symbol.for, t = r ? Symbol.for("react.element") : 60103, n = r ? Symbol.for("react.portal") : 60106, e = r ? Symbol.for("react.fragment") : 60107, i = r ? Symbol.for("react.strict_mode") : 60108, o = r ? Symbol.for("react.profiler") : 60114, s = r ? Symbol.for("react.provider") : 60109, a = r ? Symbol.for("react.context") : 60110, u = r ? Symbol.for("react.async_mode") : 60111, f = r ? Symbol.for("react.concurrent_mode") : 60111, l = r ? Symbol.for("react.forward_ref") : 60112, c = r ? Symbol.for("react.suspense") : 60113, g = r ? Symbol.for("react.suspense_list") : 60120, S = r ? Symbol.for("react.memo") : 60115, v = r ? Symbol.for("react.lazy") : 60116, p = r ? Symbol.for("react.block") : 60121, x = r ? Symbol.for("react.fundamental") : 60117, y = r ? Symbol.for("react.responder") : 60118, R = r ? Symbol.for("react.scope") : 60119;
  function P(m) {
    if (typeof m == "object" && m !== null) {
      var F = m.$$typeof;
      switch (F) {
        case t:
          switch (m = m.type, m) {
            case u:
            case f:
            case e:
            case o:
            case i:
            case c:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case a:
                case l:
                case v:
                case S:
                case s:
                  return m;
                default:
                  return F;
              }
          }
        case n:
          return F;
      }
    }
  }
  function E(m) {
    return P(m) === f;
  }
  return U.AsyncMode = u, U.ConcurrentMode = f, U.ContextConsumer = a, U.ContextProvider = s, U.Element = t, U.ForwardRef = l, U.Fragment = e, U.Lazy = v, U.Memo = S, U.Portal = n, U.Profiler = o, U.StrictMode = i, U.Suspense = c, U.isAsyncMode = function(m) {
    return E(m) || P(m) === u;
  }, U.isConcurrentMode = E, U.isContextConsumer = function(m) {
    return P(m) === a;
  }, U.isContextProvider = function(m) {
    return P(m) === s;
  }, U.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === t;
  }, U.isForwardRef = function(m) {
    return P(m) === l;
  }, U.isFragment = function(m) {
    return P(m) === e;
  }, U.isLazy = function(m) {
    return P(m) === v;
  }, U.isMemo = function(m) {
    return P(m) === S;
  }, U.isPortal = function(m) {
    return P(m) === n;
  }, U.isProfiler = function(m) {
    return P(m) === o;
  }, U.isStrictMode = function(m) {
    return P(m) === i;
  }, U.isSuspense = function(m) {
    return P(m) === c;
  }, U.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === e || m === f || m === o || m === i || m === c || m === g || typeof m == "object" && m !== null && (m.$$typeof === v || m.$$typeof === S || m.$$typeof === s || m.$$typeof === a || m.$$typeof === l || m.$$typeof === x || m.$$typeof === y || m.$$typeof === R || m.$$typeof === p);
  }, U.typeOf = P, U;
}
var W = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dr;
function Vn() {
  return dr || (dr = 1, process.env.NODE_ENV !== "production" && function() {
    var r = typeof Symbol == "function" && Symbol.for, t = r ? Symbol.for("react.element") : 60103, n = r ? Symbol.for("react.portal") : 60106, e = r ? Symbol.for("react.fragment") : 60107, i = r ? Symbol.for("react.strict_mode") : 60108, o = r ? Symbol.for("react.profiler") : 60114, s = r ? Symbol.for("react.provider") : 60109, a = r ? Symbol.for("react.context") : 60110, u = r ? Symbol.for("react.async_mode") : 60111, f = r ? Symbol.for("react.concurrent_mode") : 60111, l = r ? Symbol.for("react.forward_ref") : 60112, c = r ? Symbol.for("react.suspense") : 60113, g = r ? Symbol.for("react.suspense_list") : 60120, S = r ? Symbol.for("react.memo") : 60115, v = r ? Symbol.for("react.lazy") : 60116, p = r ? Symbol.for("react.block") : 60121, x = r ? Symbol.for("react.fundamental") : 60117, y = r ? Symbol.for("react.responder") : 60118, R = r ? Symbol.for("react.scope") : 60119;
    function P(d) {
      return typeof d == "string" || typeof d == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      d === e || d === f || d === o || d === i || d === c || d === g || typeof d == "object" && d !== null && (d.$$typeof === v || d.$$typeof === S || d.$$typeof === s || d.$$typeof === a || d.$$typeof === l || d.$$typeof === x || d.$$typeof === y || d.$$typeof === R || d.$$typeof === p);
    }
    function E(d) {
      if (typeof d == "object" && d !== null) {
        var N = d.$$typeof;
        switch (N) {
          case t:
            var J = d.type;
            switch (J) {
              case u:
              case f:
              case e:
              case o:
              case i:
              case c:
                return J;
              default:
                var K = J && J.$$typeof;
                switch (K) {
                  case a:
                  case l:
                  case v:
                  case S:
                  case s:
                    return K;
                  default:
                    return N;
                }
            }
          case n:
            return N;
        }
      }
    }
    var m = u, F = f, _ = a, L = s, z = t, q = l, G = e, ee = v, ie = S, X = n, te = o, Q = i, Z = c, re = !1;
    function ne(d) {
      return re || (re = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), b(d) || E(d) === u;
    }
    function b(d) {
      return E(d) === f;
    }
    function w(d) {
      return E(d) === a;
    }
    function I(d) {
      return E(d) === s;
    }
    function A(d) {
      return typeof d == "object" && d !== null && d.$$typeof === t;
    }
    function k(d) {
      return E(d) === l;
    }
    function D(d) {
      return E(d) === e;
    }
    function O(d) {
      return E(d) === v;
    }
    function T(d) {
      return E(d) === S;
    }
    function C(d) {
      return E(d) === n;
    }
    function $(d) {
      return E(d) === o;
    }
    function j(d) {
      return E(d) === i;
    }
    function V(d) {
      return E(d) === c;
    }
    W.AsyncMode = m, W.ConcurrentMode = F, W.ContextConsumer = _, W.ContextProvider = L, W.Element = z, W.ForwardRef = q, W.Fragment = G, W.Lazy = ee, W.Memo = ie, W.Portal = X, W.Profiler = te, W.StrictMode = Q, W.Suspense = Z, W.isAsyncMode = ne, W.isConcurrentMode = b, W.isContextConsumer = w, W.isContextProvider = I, W.isElement = A, W.isForwardRef = k, W.isFragment = D, W.isLazy = O, W.isMemo = T, W.isPortal = C, W.isProfiler = $, W.isStrictMode = j, W.isSuspense = V, W.isValidElementType = P, W.typeOf = E;
  }()), W;
}
process.env.NODE_ENV === "production" ? Et.exports = Dn() : Et.exports = Vn();
var zt = Et.exports, qt = zt, $n = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, Ln = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Fn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Kr = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Ut = {};
Ut[qt.ForwardRef] = Fn;
Ut[qt.Memo] = Kr;
function hr(r) {
  return qt.isMemo(r) ? Kr : Ut[r.$$typeof] || $n;
}
var zn = Object.defineProperty, qn = Object.getOwnPropertyNames, pr = Object.getOwnPropertySymbols, Un = Object.getOwnPropertyDescriptor, Wn = Object.getPrototypeOf, vr = Object.prototype;
function Xr(r, t, n) {
  if (typeof t != "string") {
    if (vr) {
      var e = Wn(t);
      e && e !== vr && Xr(r, e, n);
    }
    var i = qn(t);
    pr && (i = i.concat(pr(t)));
    for (var o = hr(r), s = hr(t), a = 0; a < i.length; ++a) {
      var u = i[a];
      if (!Ln[u] && !(n && n[u]) && !(s && s[u]) && !(o && o[u])) {
        var f = Un(t, u);
        try {
          zn(r, u, f);
        } catch {
        }
      }
    }
  }
  return r;
}
var Gn = Xr;
const Jn = /* @__PURE__ */ Ft(Gn);
var Bn = process.env.NODE_ENV === "production";
function H(r, t) {
  if (!Bn) {
    if (r)
      return;
    var n = "Warning: " + t;
    typeof console < "u" && console.warn(n);
    try {
      throw Error(n);
    } catch {
    }
  }
}
var Ot = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var it, gr;
function Yn() {
  if (gr)
    return it;
  gr = 1;
  var r = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function e(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var u = Object.getOwnPropertyNames(s).map(function(l) {
        return s[l];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var f = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        f[l] = l;
      }), Object.keys(Object.assign({}, f)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return it = i() ? Object.assign : function(o, s) {
    for (var a, u = e(o), f, l = 1; l < arguments.length; l++) {
      a = Object(arguments[l]);
      for (var c in a)
        t.call(a, c) && (u[c] = a[c]);
      if (r) {
        f = r(a);
        for (var g = 0; g < f.length; g++)
          n.call(a, f[g]) && (u[f[g]] = a[f[g]]);
      }
    }
    return u;
  }, it;
}
var ot, yr;
function Wt() {
  if (yr)
    return ot;
  yr = 1;
  var r = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ot = r, ot;
}
var st, mr;
function Qr() {
  return mr || (mr = 1, st = Function.call.bind(Object.prototype.hasOwnProperty)), st;
}
var at, br;
function Hn() {
  if (br)
    return at;
  br = 1;
  var r = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Wt(), n = {}, e = Qr();
    r = function(o) {
      var s = "Warning: " + o;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(o, s, a, u, f) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in o)
        if (e(o, l)) {
          var c;
          try {
            if (typeof o[l] != "function") {
              var g = Error(
                (u || "React class") + ": " + a + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            c = o[l](s, l, u, a, null, t);
          } catch (v) {
            c = v;
          }
          if (c && !(c instanceof Error) && r(
            (u || "React class") + ": type specification of " + a + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof c + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), c instanceof Error && !(c.message in n)) {
            n[c.message] = !0;
            var S = f ? f() : "";
            r(
              "Failed " + a + " type: " + c.message + (S ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, at = i, at;
}
var ut, Sr;
function Kn() {
  if (Sr)
    return ut;
  Sr = 1;
  var r = zt, t = Yn(), n = Wt(), e = Qr(), i = Hn(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(a) {
    var u = "Warning: " + a;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return ut = function(a, u) {
    var f = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function c(b) {
      var w = b && (f && b[f] || b[l]);
      if (typeof w == "function")
        return w;
    }
    var g = "<<anonymous>>", S = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: R(),
      arrayOf: P,
      element: E(),
      elementType: m(),
      instanceOf: F,
      node: q(),
      objectOf: L,
      oneOf: _,
      oneOfType: z,
      shape: ee,
      exact: ie
    };
    function v(b, w) {
      return b === w ? b !== 0 || 1 / b === 1 / w : b !== b && w !== w;
    }
    function p(b, w) {
      this.message = b, this.data = w && typeof w == "object" ? w : {}, this.stack = "";
    }
    p.prototype = Error.prototype;
    function x(b) {
      if (process.env.NODE_ENV !== "production")
        var w = {}, I = 0;
      function A(D, O, T, C, $, j, V) {
        if (C = C || g, j = j || T, V !== n) {
          if (u) {
            var d = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw d.name = "Invariant Violation", d;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var N = C + ":" + T;
            !w[N] && // Avoid spamming the console because they are often not actionable except for lib authors
            I < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + j + "` prop on `" + C + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), w[N] = !0, I++);
          }
        }
        return O[T] == null ? D ? O[T] === null ? new p("The " + $ + " `" + j + "` is marked as required " + ("in `" + C + "`, but its value is `null`.")) : new p("The " + $ + " `" + j + "` is marked as required in " + ("`" + C + "`, but its value is `undefined`.")) : null : b(O, T, C, $, j);
      }
      var k = A.bind(null, !1);
      return k.isRequired = A.bind(null, !0), k;
    }
    function y(b) {
      function w(I, A, k, D, O, T) {
        var C = I[A], $ = Q(C);
        if ($ !== b) {
          var j = Z(C);
          return new p(
            "Invalid " + D + " `" + O + "` of type " + ("`" + j + "` supplied to `" + k + "`, expected ") + ("`" + b + "`."),
            { expectedType: b }
          );
        }
        return null;
      }
      return x(w);
    }
    function R() {
      return x(s);
    }
    function P(b) {
      function w(I, A, k, D, O) {
        if (typeof b != "function")
          return new p("Property `" + O + "` of component `" + k + "` has invalid PropType notation inside arrayOf.");
        var T = I[A];
        if (!Array.isArray(T)) {
          var C = Q(T);
          return new p("Invalid " + D + " `" + O + "` of type " + ("`" + C + "` supplied to `" + k + "`, expected an array."));
        }
        for (var $ = 0; $ < T.length; $++) {
          var j = b(T, $, k, D, O + "[" + $ + "]", n);
          if (j instanceof Error)
            return j;
        }
        return null;
      }
      return x(w);
    }
    function E() {
      function b(w, I, A, k, D) {
        var O = w[I];
        if (!a(O)) {
          var T = Q(O);
          return new p("Invalid " + k + " `" + D + "` of type " + ("`" + T + "` supplied to `" + A + "`, expected a single ReactElement."));
        }
        return null;
      }
      return x(b);
    }
    function m() {
      function b(w, I, A, k, D) {
        var O = w[I];
        if (!r.isValidElementType(O)) {
          var T = Q(O);
          return new p("Invalid " + k + " `" + D + "` of type " + ("`" + T + "` supplied to `" + A + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return x(b);
    }
    function F(b) {
      function w(I, A, k, D, O) {
        if (!(I[A] instanceof b)) {
          var T = b.name || g, C = ne(I[A]);
          return new p("Invalid " + D + " `" + O + "` of type " + ("`" + C + "` supplied to `" + k + "`, expected ") + ("instance of `" + T + "`."));
        }
        return null;
      }
      return x(w);
    }
    function _(b) {
      if (!Array.isArray(b))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function w(I, A, k, D, O) {
        for (var T = I[A], C = 0; C < b.length; C++)
          if (v(T, b[C]))
            return null;
        var $ = JSON.stringify(b, function(V, d) {
          var N = Z(d);
          return N === "symbol" ? String(d) : d;
        });
        return new p("Invalid " + D + " `" + O + "` of value `" + String(T) + "` " + ("supplied to `" + k + "`, expected one of " + $ + "."));
      }
      return x(w);
    }
    function L(b) {
      function w(I, A, k, D, O) {
        if (typeof b != "function")
          return new p("Property `" + O + "` of component `" + k + "` has invalid PropType notation inside objectOf.");
        var T = I[A], C = Q(T);
        if (C !== "object")
          return new p("Invalid " + D + " `" + O + "` of type " + ("`" + C + "` supplied to `" + k + "`, expected an object."));
        for (var $ in T)
          if (e(T, $)) {
            var j = b(T, $, k, D, O + "." + $, n);
            if (j instanceof Error)
              return j;
          }
        return null;
      }
      return x(w);
    }
    function z(b) {
      if (!Array.isArray(b))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var w = 0; w < b.length; w++) {
        var I = b[w];
        if (typeof I != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + re(I) + " at index " + w + "."
          ), s;
      }
      function A(k, D, O, T, C) {
        for (var $ = [], j = 0; j < b.length; j++) {
          var V = b[j], d = V(k, D, O, T, C, n);
          if (d == null)
            return null;
          d.data && e(d.data, "expectedType") && $.push(d.data.expectedType);
        }
        var N = $.length > 0 ? ", expected one of type [" + $.join(", ") + "]" : "";
        return new p("Invalid " + T + " `" + C + "` supplied to " + ("`" + O + "`" + N + "."));
      }
      return x(A);
    }
    function q() {
      function b(w, I, A, k, D) {
        return X(w[I]) ? null : new p("Invalid " + k + " `" + D + "` supplied to " + ("`" + A + "`, expected a ReactNode."));
      }
      return x(b);
    }
    function G(b, w, I, A, k) {
      return new p(
        (b || "React class") + ": " + w + " type `" + I + "." + A + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + k + "`."
      );
    }
    function ee(b) {
      function w(I, A, k, D, O) {
        var T = I[A], C = Q(T);
        if (C !== "object")
          return new p("Invalid " + D + " `" + O + "` of type `" + C + "` " + ("supplied to `" + k + "`, expected `object`."));
        for (var $ in b) {
          var j = b[$];
          if (typeof j != "function")
            return G(k, D, O, $, Z(j));
          var V = j(T, $, k, D, O + "." + $, n);
          if (V)
            return V;
        }
        return null;
      }
      return x(w);
    }
    function ie(b) {
      function w(I, A, k, D, O) {
        var T = I[A], C = Q(T);
        if (C !== "object")
          return new p("Invalid " + D + " `" + O + "` of type `" + C + "` " + ("supplied to `" + k + "`, expected `object`."));
        var $ = t({}, I[A], b);
        for (var j in $) {
          var V = b[j];
          if (e(b, j) && typeof V != "function")
            return G(k, D, O, j, Z(V));
          if (!V)
            return new p(
              "Invalid " + D + " `" + O + "` key `" + j + "` supplied to `" + k + "`.\nBad object: " + JSON.stringify(I[A], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(b), null, "  ")
            );
          var d = V(T, j, k, D, O + "." + j, n);
          if (d)
            return d;
        }
        return null;
      }
      return x(w);
    }
    function X(b) {
      switch (typeof b) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !b;
        case "object":
          if (Array.isArray(b))
            return b.every(X);
          if (b === null || a(b))
            return !0;
          var w = c(b);
          if (w) {
            var I = w.call(b), A;
            if (w !== b.entries) {
              for (; !(A = I.next()).done; )
                if (!X(A.value))
                  return !1;
            } else
              for (; !(A = I.next()).done; ) {
                var k = A.value;
                if (k && !X(k[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function te(b, w) {
      return b === "symbol" ? !0 : w ? w["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && w instanceof Symbol : !1;
    }
    function Q(b) {
      var w = typeof b;
      return Array.isArray(b) ? "array" : b instanceof RegExp ? "object" : te(w, b) ? "symbol" : w;
    }
    function Z(b) {
      if (typeof b > "u" || b === null)
        return "" + b;
      var w = Q(b);
      if (w === "object") {
        if (b instanceof Date)
          return "date";
        if (b instanceof RegExp)
          return "regexp";
      }
      return w;
    }
    function re(b) {
      var w = Z(b);
      switch (w) {
        case "array":
        case "object":
          return "an " + w;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + w;
        default:
          return w;
      }
    }
    function ne(b) {
      return !b.constructor || !b.constructor.name ? g : b.constructor.name;
    }
    return S.checkPropTypes = i, S.resetWarningCache = i.resetWarningCache, S.PropTypes = S, S;
  }, ut;
}
var ft, xr;
function Xn() {
  if (xr)
    return ft;
  xr = 1;
  var r = Wt();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, ft = function() {
    function e(s, a, u, f, l, c) {
      if (c !== r) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    e.isRequired = e;
    function i() {
      return e;
    }
    var o = {
      array: e,
      bigint: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: i,
      element: e,
      elementType: e,
      instanceOf: i,
      node: e,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, ft;
}
if (process.env.NODE_ENV !== "production") {
  var Qn = zt, Zn = !0;
  Ot.exports = Kn()(Qn.isElement, Zn);
} else
  Ot.exports = Xn()();
var ei = Ot.exports;
const Fe = /* @__PURE__ */ Ft(ei);
var Zr = {};
Object.defineProperty(Zr, "__esModule", {
  value: !0
});
var ti = Zr.default = ri;
function ri(r) {
  return r.displayName || r.name || (typeof r == "string" && r.length > 0 ? r : "Unknown");
}
function ze(r, t, n) {
  return t in r ? Object.defineProperty(r, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[t] = n, r;
}
function Je() {
  return Je = Object.assign || function(r) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var e in n)
        Object.prototype.hasOwnProperty.call(n, e) && (r[e] = n[e]);
    }
    return r;
  }, Je.apply(this, arguments);
}
function ni(r, t) {
  r.prototype = Object.create(t.prototype), r.prototype.constructor = r, r.__proto__ = t;
}
function fe(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function Be(r) {
  return r !== null && typeof r == "object" && !Array.isArray(r);
}
function ii(r) {
  var t = /* @__PURE__ */ function(n) {
    ni(e, n);
    function e() {
      for (var o, s = arguments.length, a = new Array(s), u = 0; u < s; u++)
        a[u] = arguments[u];
      return o = n.call.apply(n, [this].concat(a)) || this, ze(fe(fe(o)), "cachedTheme", void 0), ze(fe(fe(o)), "lastOuterTheme", void 0), ze(fe(fe(o)), "lastTheme", void 0), ze(fe(fe(o)), "renderProvider", function(f) {
        var l = o.props.children;
        return le.createElement(r.Provider, {
          value: o.getTheme(f)
        }, l);
      }), o;
    }
    var i = e.prototype;
    return i.getTheme = function(s) {
      if (this.props.theme !== this.lastTheme || s !== this.lastOuterTheme || !this.cachedTheme)
        if (this.lastOuterTheme = s, this.lastTheme = this.props.theme, typeof this.lastTheme == "function") {
          var a = this.props.theme;
          this.cachedTheme = a(s), process.env.NODE_ENV !== "production" && H(Be(this.cachedTheme), "[ThemeProvider] Please return an object from your theme function");
        } else {
          var u = this.props.theme;
          process.env.NODE_ENV !== "production" && H(Be(u), "[ThemeProvider] Please make your theme prop a plain object"), this.cachedTheme = s ? Je({}, s, u) : u;
        }
      return this.cachedTheme;
    }, i.render = function() {
      var s = this.props.children;
      return s ? le.createElement(r.Consumer, null, this.renderProvider) : null;
    }, e;
  }(le.Component);
  return process.env.NODE_ENV !== "production" && (t.propTypes = {
    // eslint-disable-next-line react/require-default-props
    children: Fe.node,
    theme: Fe.oneOfType([Fe.shape({}), Fe.func]).isRequired
  }), t;
}
function oi(r) {
  return function(n) {
    var e = le.forwardRef(function(i, o) {
      return le.createElement(r.Consumer, null, function(s) {
        return process.env.NODE_ENV !== "production" && H(Be(s), "[theming] Please use withTheme only with the ThemeProvider"), le.createElement(n, Je({
          theme: s,
          ref: o
        }, i));
      });
    });
    return process.env.NODE_ENV !== "production" && (e.displayName = "WithTheme(" + ti(n) + ")"), Jn(e, n), e;
  };
}
function si(r) {
  var t = function() {
    var e = le.useContext(r);
    return process.env.NODE_ENV !== "production" && H(Be(e), "[theming] Please use useTheme only with the ThemeProvider"), e;
  };
  return t;
}
function ai(r) {
  return {
    context: r,
    withTheme: oi(r),
    useTheme: si(r),
    ThemeProvider: ii(r)
  };
}
var en = Yr();
ai(en);
var Rr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
  return typeof r;
} : function(r) {
  return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, we = (typeof window > "u" ? "undefined" : Rr(window)) === "object" && (typeof document > "u" ? "undefined" : Rr(document)) === "object" && document.nodeType === 9;
function _e(r) {
  "@babel/helpers - typeof";
  return _e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _e(r);
}
function ui(r, t) {
  if (_e(r) != "object" || !r)
    return r;
  var n = r[Symbol.toPrimitive];
  if (n !== void 0) {
    var e = n.call(r, t);
    if (_e(e) != "object")
      return e;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(r);
}
function fi(r) {
  var t = ui(r, "string");
  return _e(t) == "symbol" ? t : t + "";
}
function ci(r, t) {
  for (var n = 0; n < t.length; n++) {
    var e = t[n];
    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(r, fi(e.key), e);
  }
}
function Gt(r, t, n) {
  return t && ci(r.prototype, t), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function Tt(r, t) {
  return Tt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, i) {
    return e.__proto__ = i, e;
  }, Tt(r, t);
}
function tn(r, t) {
  r.prototype = Object.create(t.prototype), r.prototype.constructor = r, Tt(r, t);
}
function Pr(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
var li = {}.constructor;
function Ct(r) {
  if (r == null || typeof r != "object")
    return r;
  if (Array.isArray(r))
    return r.map(Ct);
  if (r.constructor !== li)
    return r;
  var t = {};
  for (var n in r)
    t[n] = Ct(r[n]);
  return t;
}
function Ke(r, t, n) {
  r === void 0 && (r = "unnamed");
  var e = n.jss, i = Ct(t), o = e.plugins.onCreateRule(r, i, n);
  return o || (r[0] === "@" && process.env.NODE_ENV !== "production" && H(!1, "[JSS] Unknown rule " + r), null);
}
var wr = function(t, n) {
  for (var e = "", i = 0; i < t.length && t[i] !== "!important"; i++)
    e && (e += n), e += t[i];
  return e;
}, me = function(t) {
  if (!Array.isArray(t))
    return t;
  var n = "";
  if (Array.isArray(t[0]))
    for (var e = 0; e < t.length && t[e] !== "!important"; e++)
      n && (n += ", "), n += wr(t[e], " ");
  else
    n = wr(t, ", ");
  return t[t.length - 1] === "!important" && (n += " !important"), n;
};
function Ee(r) {
  return r && r.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function Oe(r, t) {
  for (var n = "", e = 0; e < t; e++)
    n += "  ";
  return n + r;
}
function Ie(r, t, n) {
  n === void 0 && (n = {});
  var e = "";
  if (!t)
    return e;
  var i = n, o = i.indent, s = o === void 0 ? 0 : o, a = t.fallbacks;
  n.format === !1 && (s = -1 / 0);
  var u = Ee(n), f = u.linebreak, l = u.space;
  if (r && s++, a)
    if (Array.isArray(a))
      for (var c = 0; c < a.length; c++) {
        var g = a[c];
        for (var S in g) {
          var v = g[S];
          v != null && (e && (e += f), e += Oe(S + ":" + l + me(v) + ";", s));
        }
      }
    else
      for (var p in a) {
        var x = a[p];
        x != null && (e && (e += f), e += Oe(p + ":" + l + me(x) + ";", s));
      }
  for (var y in t) {
    var R = t[y];
    R != null && y !== "fallbacks" && (e && (e += f), e += Oe(y + ":" + l + me(R) + ";", s));
  }
  return !e && !n.allowEmpty || !r ? e : (s--, e && (e = "" + f + e + f), Oe("" + r + l + "{" + e, s) + Oe("}", s));
}
var di = /([[\].#*$><+~=|^:(),"'`\s])/g, Er = typeof CSS < "u" && CSS.escape, Jt = function(r) {
  return Er ? Er(r) : r.replace(di, "\\$1");
}, rn = /* @__PURE__ */ function() {
  function r(n, e, i) {
    this.type = "style", this.isProcessed = !1;
    var o = i.sheet, s = i.Renderer;
    this.key = n, this.options = i, this.style = e, o ? this.renderer = o.renderer : s && (this.renderer = new s());
  }
  var t = r.prototype;
  return t.prop = function(e, i, o) {
    if (i === void 0)
      return this.style[e];
    var s = o ? o.force : !1;
    if (!s && this.style[e] === i)
      return this;
    var a = i;
    (!o || o.process !== !1) && (a = this.options.jss.plugins.onChangeValue(i, e, this));
    var u = a == null || a === !1, f = e in this.style;
    if (u && !f && !s)
      return this;
    var l = u && f;
    if (l ? delete this.style[e] : this.style[e] = a, this.renderable && this.renderer)
      return l ? this.renderer.removeProperty(this.renderable, e) : this.renderer.setProperty(this.renderable, e, a), this;
    var c = this.options.sheet;
    return c && c.attached && process.env.NODE_ENV !== "production" && H(!1, '[JSS] Rule is not linked. Missing sheet option "link: true".'), this;
  }, r;
}(), At = /* @__PURE__ */ function(r) {
  tn(t, r);
  function t(e, i, o) {
    var s;
    s = r.call(this, e, i, o) || this;
    var a = o.selector, u = o.scoped, f = o.sheet, l = o.generateId;
    return a ? s.selectorText = a : u !== !1 && (s.id = l(Pr(Pr(s)), f), s.selectorText = "." + Jt(s.id)), s;
  }
  var n = t.prototype;
  return n.applyTo = function(i) {
    var o = this.renderer;
    if (o) {
      var s = this.toJSON();
      for (var a in s)
        o.setProperty(i, a, s[a]);
    }
    return this;
  }, n.toJSON = function() {
    var i = {};
    for (var o in this.style) {
      var s = this.style[o];
      typeof s != "object" ? i[o] = s : Array.isArray(s) && (i[o] = me(s));
    }
    return i;
  }, n.toString = function(i) {
    var o = this.options.sheet, s = o ? o.options.link : !1, a = s ? Y({}, i, {
      allowEmpty: !0
    }) : i;
    return Ie(this.selectorText, this.style, a);
  }, Gt(t, [{
    key: "selector",
    set: function(i) {
      if (i !== this.selectorText) {
        this.selectorText = i;
        var o = this.renderer, s = this.renderable;
        if (!(!s || !o)) {
          var a = o.setSelector(s, i);
          a || o.replaceRule(s, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), t;
}(rn), hi = {
  onCreateRule: function(t, n, e) {
    return t[0] === "@" || e.parent && e.parent.type === "keyframes" ? null : new At(t, n, e);
  }
}, ct = {
  indent: 1,
  children: !0
}, pi = /@([\w-]+)/, vi = /* @__PURE__ */ function() {
  function r(n, e, i) {
    this.type = "conditional", this.isProcessed = !1, this.key = n;
    var o = n.match(pi);
    this.at = o ? o[1] : "unknown", this.query = i.name || "@" + this.at, this.options = i, this.rules = new Xe(Y({}, i, {
      parent: this
    }));
    for (var s in e)
      this.rules.add(s, e[s]);
    this.rules.process();
  }
  var t = r.prototype;
  return t.getRule = function(e) {
    return this.rules.get(e);
  }, t.indexOf = function(e) {
    return this.rules.indexOf(e);
  }, t.addRule = function(e, i, o) {
    var s = this.rules.add(e, i, o);
    return s ? (this.options.jss.plugins.onProcessRule(s), s) : null;
  }, t.replaceRule = function(e, i, o) {
    var s = this.rules.replace(e, i, o);
    return s && this.options.jss.plugins.onProcessRule(s), s;
  }, t.toString = function(e) {
    e === void 0 && (e = ct);
    var i = Ee(e), o = i.linebreak;
    if (e.indent == null && (e.indent = ct.indent), e.children == null && (e.children = ct.children), e.children === !1)
      return this.query + " {}";
    var s = this.rules.toString(e);
    return s ? this.query + " {" + o + s + o + "}" : "";
  }, r;
}(), gi = /@container|@media|@supports\s+/, yi = {
  onCreateRule: function(t, n, e) {
    return gi.test(t) ? new vi(t, n, e) : null;
  }
}, lt = {
  indent: 1,
  children: !0
}, mi = /@keyframes\s+([\w-]+)/, kt = /* @__PURE__ */ function() {
  function r(n, e, i) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var o = n.match(mi);
    o && o[1] ? this.name = o[1] : (this.name = "noname", process.env.NODE_ENV !== "production" && H(!1, "[JSS] Bad keyframes name " + n)), this.key = this.type + "-" + this.name, this.options = i;
    var s = i.scoped, a = i.sheet, u = i.generateId;
    this.id = s === !1 ? this.name : Jt(u(this, a)), this.rules = new Xe(Y({}, i, {
      parent: this
    }));
    for (var f in e)
      this.rules.add(f, e[f], Y({}, i, {
        parent: this
      }));
    this.rules.process();
  }
  var t = r.prototype;
  return t.toString = function(e) {
    e === void 0 && (e = lt);
    var i = Ee(e), o = i.linebreak;
    if (e.indent == null && (e.indent = lt.indent), e.children == null && (e.children = lt.children), e.children === !1)
      return this.at + " " + this.id + " {}";
    var s = this.rules.toString(e);
    return s && (s = "" + o + s + o), this.at + " " + this.id + " {" + s + "}";
  }, r;
}(), bi = /@keyframes\s+/, Si = /\$([\w-]+)/g, jt = function(t, n) {
  return typeof t == "string" ? t.replace(Si, function(e, i) {
    return i in n ? n[i] : (process.env.NODE_ENV !== "production" && H(!1, '[JSS] Referenced keyframes rule "' + i + '" is not defined.'), e);
  }) : t;
}, Or = function(t, n, e) {
  var i = t[n], o = jt(i, e);
  o !== i && (t[n] = o);
}, xi = {
  onCreateRule: function(t, n, e) {
    return typeof t == "string" && bi.test(t) ? new kt(t, n, e) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(t, n, e) {
    return n.type !== "style" || !e || ("animation-name" in t && Or(t, "animation-name", e.keyframes), "animation" in t && Or(t, "animation", e.keyframes)), t;
  },
  onChangeValue: function(t, n, e) {
    var i = e.options.sheet;
    if (!i)
      return t;
    switch (n) {
      case "animation":
        return jt(t, i.keyframes);
      case "animation-name":
        return jt(t, i.keyframes);
      default:
        return t;
    }
  }
}, Ri = /* @__PURE__ */ function(r) {
  tn(t, r);
  function t() {
    return r.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.toString = function(i) {
    var o = this.options.sheet, s = o ? o.options.link : !1, a = s ? Y({}, i, {
      allowEmpty: !0
    }) : i;
    return Ie(this.key, this.style, a);
  }, t;
}(rn), Pi = {
  onCreateRule: function(t, n, e) {
    return e.parent && e.parent.type === "keyframes" ? new Ri(t, n, e) : null;
  }
}, wi = /* @__PURE__ */ function() {
  function r(n, e, i) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = n, this.style = e, this.options = i;
  }
  var t = r.prototype;
  return t.toString = function(e) {
    var i = Ee(e), o = i.linebreak;
    if (Array.isArray(this.style)) {
      for (var s = "", a = 0; a < this.style.length; a++)
        s += Ie(this.at, this.style[a]), this.style[a + 1] && (s += o);
      return s;
    }
    return Ie(this.at, this.style, e);
  }, r;
}(), Ei = /@font-face/, Oi = {
  onCreateRule: function(t, n, e) {
    return Ei.test(t) ? new wi(t, n, e) : null;
  }
}, Ti = /* @__PURE__ */ function() {
  function r(n, e, i) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = n, this.style = e, this.options = i;
  }
  var t = r.prototype;
  return t.toString = function(e) {
    return Ie(this.key, this.style, e);
  }, r;
}(), Ci = {
  onCreateRule: function(t, n, e) {
    return t === "@viewport" || t === "@-ms-viewport" ? new Ti(t, n, e) : null;
  }
}, Ai = /* @__PURE__ */ function() {
  function r(n, e, i) {
    this.type = "simple", this.isProcessed = !1, this.key = n, this.value = e, this.options = i;
  }
  var t = r.prototype;
  return t.toString = function(e) {
    if (Array.isArray(this.value)) {
      for (var i = "", o = 0; o < this.value.length; o++)
        i += this.key + " " + this.value[o] + ";", this.value[o + 1] && (i += `
`);
      return i;
    }
    return this.key + " " + this.value + ";";
  }, r;
}(), ki = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, ji = {
  onCreateRule: function(t, n, e) {
    return t in ki ? new Ai(t, n, e) : null;
  }
}, Tr = [hi, yi, xi, Pi, Oi, Ci, ji], _i = {
  process: !0
}, Cr = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, Xe = /* @__PURE__ */ function() {
  function r(n) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = n, this.classes = n.classes, this.keyframes = n.keyframes;
  }
  var t = r.prototype;
  return t.add = function(e, i, o) {
    var s = this.options, a = s.parent, u = s.sheet, f = s.jss, l = s.Renderer, c = s.generateId, g = s.scoped, S = Y({
      classes: this.classes,
      parent: a,
      sheet: u,
      jss: f,
      Renderer: l,
      generateId: c,
      scoped: g,
      name: e,
      keyframes: this.keyframes,
      selector: void 0
    }, o), v = e;
    e in this.raw && (v = e + "-d" + this.counter++), this.raw[v] = i, v in this.classes && (S.selector = "." + Jt(this.classes[v]));
    var p = Ke(v, i, S);
    if (!p)
      return null;
    this.register(p);
    var x = S.index === void 0 ? this.index.length : S.index;
    return this.index.splice(x, 0, p), p;
  }, t.replace = function(e, i, o) {
    var s = this.get(e), a = this.index.indexOf(s);
    s && this.remove(s);
    var u = o;
    return a !== -1 && (u = Y({}, o, {
      index: a
    })), this.add(e, i, u);
  }, t.get = function(e) {
    return this.map[e];
  }, t.remove = function(e) {
    this.unregister(e), delete this.raw[e.key], this.index.splice(this.index.indexOf(e), 1);
  }, t.indexOf = function(e) {
    return this.index.indexOf(e);
  }, t.process = function() {
    var e = this.options.jss.plugins;
    this.index.slice(0).forEach(e.onProcessRule, e);
  }, t.register = function(e) {
    this.map[e.key] = e, e instanceof At ? (this.map[e.selector] = e, e.id && (this.classes[e.key] = e.id)) : e instanceof kt && this.keyframes && (this.keyframes[e.name] = e.id);
  }, t.unregister = function(e) {
    delete this.map[e.key], e instanceof At ? (delete this.map[e.selector], delete this.classes[e.key]) : e instanceof kt && delete this.keyframes[e.name];
  }, t.update = function() {
    var e, i, o;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (e = arguments.length <= 0 ? void 0 : arguments[0], i = arguments.length <= 1 ? void 0 : arguments[1], o = arguments.length <= 2 ? void 0 : arguments[2]) : (i = arguments.length <= 0 ? void 0 : arguments[0], o = arguments.length <= 1 ? void 0 : arguments[1], e = null), e)
      this.updateOne(this.get(e), i, o);
    else
      for (var s = 0; s < this.index.length; s++)
        this.updateOne(this.index[s], i, o);
  }, t.updateOne = function(e, i, o) {
    o === void 0 && (o = _i);
    var s = this.options, a = s.jss.plugins, u = s.sheet;
    if (e.rules instanceof r) {
      e.rules.update(i, o);
      return;
    }
    var f = e.style;
    if (a.onUpdate(i, e, u, o), o.process && f && f !== e.style) {
      a.onProcessStyle(e.style, e, u);
      for (var l in e.style) {
        var c = e.style[l], g = f[l];
        c !== g && e.prop(l, c, Cr);
      }
      for (var S in f) {
        var v = e.style[S], p = f[S];
        v == null && v !== p && e.prop(S, null, Cr);
      }
    }
  }, t.toString = function(e) {
    for (var i = "", o = this.options.sheet, s = o ? o.options.link : !1, a = Ee(e), u = a.linebreak, f = 0; f < this.index.length; f++) {
      var l = this.index[f], c = l.toString(e);
      !c && !s || (i && (i += u), i += c);
    }
    return i;
  }, r;
}(), nn = /* @__PURE__ */ function() {
  function r(n, e) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = Y({}, e, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), e.Renderer && (this.renderer = new e.Renderer(this)), this.rules = new Xe(this.options);
    for (var i in n)
      this.rules.add(i, n[i]);
    this.rules.process();
  }
  var t = r.prototype;
  return t.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, t.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, t.addRule = function(e, i, o) {
    var s = this.queue;
    this.attached && !s && (this.queue = []);
    var a = this.rules.add(e, i, o);
    return a ? (this.options.jss.plugins.onProcessRule(a), this.attached ? (this.deployed && (s ? s.push(a) : (this.insertRule(a), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), a) : (this.deployed = !1, a)) : null;
  }, t.replaceRule = function(e, i, o) {
    var s = this.rules.get(e);
    if (!s)
      return this.addRule(e, i, o);
    var a = this.rules.replace(e, i, o);
    return a && this.options.jss.plugins.onProcessRule(a), this.attached ? (this.deployed && this.renderer && (a ? s.renderable && this.renderer.replaceRule(s.renderable, a) : this.renderer.deleteRule(s)), a) : (this.deployed = !1, a);
  }, t.insertRule = function(e) {
    this.renderer && this.renderer.insertRule(e);
  }, t.addRules = function(e, i) {
    var o = [];
    for (var s in e) {
      var a = this.addRule(s, e[s], i);
      a && o.push(a);
    }
    return o;
  }, t.getRule = function(e) {
    return this.rules.get(e);
  }, t.deleteRule = function(e) {
    var i = typeof e == "object" ? e : this.rules.get(e);
    return !i || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !i.renderable ? !1 : (this.rules.remove(i), this.attached && i.renderable && this.renderer ? this.renderer.deleteRule(i.renderable) : !0);
  }, t.indexOf = function(e) {
    return this.rules.indexOf(e);
  }, t.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, t.update = function() {
    var e;
    return (e = this.rules).update.apply(e, arguments), this;
  }, t.updateOne = function(e, i, o) {
    return this.rules.updateOne(e, i, o), this;
  }, t.toString = function(e) {
    return this.rules.toString(e);
  }, r;
}(), Ii = /* @__PURE__ */ function() {
  function r() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var t = r.prototype;
  return t.onCreateRule = function(e, i, o) {
    for (var s = 0; s < this.registry.onCreateRule.length; s++) {
      var a = this.registry.onCreateRule[s](e, i, o);
      if (a)
        return a;
    }
    return null;
  }, t.onProcessRule = function(e) {
    if (!e.isProcessed) {
      for (var i = e.options.sheet, o = 0; o < this.registry.onProcessRule.length; o++)
        this.registry.onProcessRule[o](e, i);
      e.style && this.onProcessStyle(e.style, e, i), e.isProcessed = !0;
    }
  }, t.onProcessStyle = function(e, i, o) {
    for (var s = 0; s < this.registry.onProcessStyle.length; s++)
      i.style = this.registry.onProcessStyle[s](i.style, i, o);
  }, t.onProcessSheet = function(e) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++)
      this.registry.onProcessSheet[i](e);
  }, t.onUpdate = function(e, i, o, s) {
    for (var a = 0; a < this.registry.onUpdate.length; a++)
      this.registry.onUpdate[a](e, i, o, s);
  }, t.onChangeValue = function(e, i, o) {
    for (var s = e, a = 0; a < this.registry.onChangeValue.length; a++)
      s = this.registry.onChangeValue[a](s, i, o);
    return s;
  }, t.use = function(e, i) {
    i === void 0 && (i = {
      queue: "external"
    });
    var o = this.plugins[i.queue];
    o.indexOf(e) === -1 && (o.push(e), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(s, a) {
      for (var u in a)
        u in s ? s[u].push(a[u]) : process.env.NODE_ENV !== "production" && H(!1, '[JSS] Unknown hook "' + u + '".');
      return s;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, r;
}(), Mi = /* @__PURE__ */ function() {
  function r() {
    this.registry = [];
  }
  var t = r.prototype;
  return t.add = function(e) {
    var i = this.registry, o = e.options.index;
    if (i.indexOf(e) === -1) {
      if (i.length === 0 || o >= this.index) {
        i.push(e);
        return;
      }
      for (var s = 0; s < i.length; s++)
        if (i[s].options.index > o) {
          i.splice(s, 0, e);
          return;
        }
    }
  }, t.reset = function() {
    this.registry = [];
  }, t.remove = function(e) {
    var i = this.registry.indexOf(e);
    this.registry.splice(i, 1);
  }, t.toString = function(e) {
    for (var i = e === void 0 ? {} : e, o = i.attached, s = Hr(i, ["attached"]), a = Ee(s), u = a.linebreak, f = "", l = 0; l < this.registry.length; l++) {
      var c = this.registry[l];
      o != null && c.attached !== o || (f && (f += u), f += c.toString(s));
    }
    return f;
  }, Gt(r, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), r;
}(), Ae = new Mi(), _t = typeof globalThis < "u" ? globalThis : typeof window < "u" && window.Math === Math ? window : typeof self < "u" && self.Math === Math ? self : Function("return this")(), It = "2f1acc6c3a606b082e5eef5e54414ffb";
_t[It] == null && (_t[It] = 0);
var Ar = _t[It]++, Ni = 1e10, kr = function(t) {
  t === void 0 && (t = {});
  var n = 0, e = function(o, s) {
    n += 1, n > Ni && process.env.NODE_ENV !== "production" && H(!1, "[JSS] You might have a memory leak. Rule counter is at " + n + ".");
    var a = "", u = "";
    return s && (s.options.classNamePrefix && (u = s.options.classNamePrefix), s.options.jss.id != null && (a = String(s.options.jss.id))), t.minify ? "" + (u || "c") + Ar + a + n : u + o.key + "-" + Ar + (a ? "-" + a : "") + "-" + n;
  };
  return e;
}, on = function(t) {
  var n;
  return function() {
    return n || (n = t()), n;
  };
}, Di = function(t, n) {
  try {
    return t.attributeStyleMap ? t.attributeStyleMap.get(n) : t.style.getPropertyValue(n);
  } catch {
    return "";
  }
}, Vi = function(t, n, e) {
  try {
    var i = e;
    if (Array.isArray(e) && (i = me(e)), t.attributeStyleMap)
      t.attributeStyleMap.set(n, i);
    else {
      var o = i ? i.indexOf("!important") : -1, s = o > -1 ? i.substr(0, o - 1) : i;
      t.style.setProperty(n, s, o > -1 ? "important" : "");
    }
  } catch {
    return !1;
  }
  return !0;
}, $i = function(t, n) {
  try {
    t.attributeStyleMap ? t.attributeStyleMap.delete(n) : t.style.removeProperty(n);
  } catch (e) {
    process.env.NODE_ENV !== "production" && H(!1, '[JSS] DOMException "' + e.message + '" was thrown. Tried to remove property "' + n + '".');
  }
}, Li = function(t, n) {
  return t.selectorText = n, t.selectorText === n;
}, sn = on(function() {
  return document.querySelector("head");
});
function Fi(r, t) {
  for (var n = 0; n < r.length; n++) {
    var e = r[n];
    if (e.attached && e.options.index > t.index && e.options.insertionPoint === t.insertionPoint)
      return e;
  }
  return null;
}
function zi(r, t) {
  for (var n = r.length - 1; n >= 0; n--) {
    var e = r[n];
    if (e.attached && e.options.insertionPoint === t.insertionPoint)
      return e;
  }
  return null;
}
function qi(r) {
  for (var t = sn(), n = 0; n < t.childNodes.length; n++) {
    var e = t.childNodes[n];
    if (e.nodeType === 8 && e.nodeValue.trim() === r)
      return e;
  }
  return null;
}
function Ui(r) {
  var t = Ae.registry;
  if (t.length > 0) {
    var n = Fi(t, r);
    if (n && n.renderer)
      return {
        parent: n.renderer.element.parentNode,
        node: n.renderer.element
      };
    if (n = zi(t, r), n && n.renderer)
      return {
        parent: n.renderer.element.parentNode,
        node: n.renderer.element.nextSibling
      };
  }
  var e = r.insertionPoint;
  if (e && typeof e == "string") {
    var i = qi(e);
    if (i)
      return {
        parent: i.parentNode,
        node: i.nextSibling
      };
    process.env.NODE_ENV !== "production" && H(!1, '[JSS] Insertion point "' + e + '" not found.');
  }
  return !1;
}
function Wi(r, t) {
  var n = t.insertionPoint, e = Ui(t);
  if (e !== !1 && e.parent) {
    e.parent.insertBefore(r, e.node);
    return;
  }
  if (n && typeof n.nodeType == "number") {
    var i = n, o = i.parentNode;
    o ? o.insertBefore(r, i.nextSibling) : process.env.NODE_ENV !== "production" && H(!1, "[JSS] Insertion point is not in the DOM.");
    return;
  }
  sn().appendChild(r);
}
var Gi = on(function() {
  var r = document.querySelector('meta[property="csp-nonce"]');
  return r ? r.getAttribute("content") : null;
}), jr = function(t, n, e) {
  try {
    "insertRule" in t ? t.insertRule(n, e) : "appendRule" in t && t.appendRule(n);
  } catch (i) {
    return process.env.NODE_ENV !== "production" && H(!1, "[JSS] " + i.message), !1;
  }
  return t.cssRules[e];
}, _r = function(t, n) {
  var e = t.cssRules.length;
  return n === void 0 || n > e ? e : n;
}, Ji = function() {
  var t = document.createElement("style");
  return t.textContent = `
`, t;
}, Bi = /* @__PURE__ */ function() {
  function r(n) {
    this.getPropertyValue = Di, this.setProperty = Vi, this.removeProperty = $i, this.setSelector = Li, this.hasInsertedRules = !1, this.cssRules = [], n && Ae.add(n), this.sheet = n;
    var e = this.sheet ? this.sheet.options : {}, i = e.media, o = e.meta, s = e.element;
    this.element = s || Ji(), this.element.setAttribute("data-jss", ""), i && this.element.setAttribute("media", i), o && this.element.setAttribute("data-meta", o);
    var a = Gi();
    a && this.element.setAttribute("nonce", a);
  }
  var t = r.prototype;
  return t.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      Wi(this.element, this.sheet.options);
      var e = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && e && (this.hasInsertedRules = !1, this.deploy());
    }
  }, t.detach = function() {
    if (this.sheet) {
      var e = this.element.parentNode;
      e && e.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, t.deploy = function() {
    var e = this.sheet;
    if (e) {
      if (e.options.link) {
        this.insertRules(e.rules);
        return;
      }
      this.element.textContent = `
` + e.toString() + `
`;
    }
  }, t.insertRules = function(e, i) {
    for (var o = 0; o < e.index.length; o++)
      this.insertRule(e.index[o], o, i);
  }, t.insertRule = function(e, i, o) {
    if (o === void 0 && (o = this.element.sheet), e.rules) {
      var s = e, a = o;
      if (e.type === "conditional" || e.type === "keyframes") {
        var u = _r(o, i);
        if (a = jr(o, s.toString({
          children: !1
        }), u), a === !1)
          return !1;
        this.refCssRule(e, u, a);
      }
      return this.insertRules(s.rules, a), a;
    }
    var f = e.toString();
    if (!f)
      return !1;
    var l = _r(o, i), c = jr(o, f, l);
    return c === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(e, l, c), c);
  }, t.refCssRule = function(e, i, o) {
    e.renderable = o, e.options.parent instanceof nn && this.cssRules.splice(i, 0, o);
  }, t.deleteRule = function(e) {
    var i = this.element.sheet, o = this.indexOf(e);
    return o === -1 ? !1 : (i.deleteRule(o), this.cssRules.splice(o, 1), !0);
  }, t.indexOf = function(e) {
    return this.cssRules.indexOf(e);
  }, t.replaceRule = function(e, i) {
    var o = this.indexOf(e);
    return o === -1 ? !1 : (this.element.sheet.deleteRule(o), this.cssRules.splice(o, 1), this.insertRule(i, o));
  }, t.getRules = function() {
    return this.element.sheet.cssRules;
  }, r;
}(), Yi = 0, Hi = /* @__PURE__ */ function() {
  function r(n) {
    this.id = Yi++, this.version = "10.10.0", this.plugins = new Ii(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: kr,
      Renderer: we ? Bi : null,
      plugins: []
    }, this.generateId = kr({
      minify: !1
    });
    for (var e = 0; e < Tr.length; e++)
      this.plugins.use(Tr[e], {
        queue: "internal"
      });
    this.setup(n);
  }
  var t = r.prototype;
  return t.setup = function(e) {
    return e === void 0 && (e = {}), e.createGenerateId && (this.options.createGenerateId = e.createGenerateId), e.id && (this.options.id = Y({}, this.options.id, e.id)), (e.createGenerateId || e.id) && (this.generateId = this.options.createGenerateId(this.options.id)), e.insertionPoint != null && (this.options.insertionPoint = e.insertionPoint), "Renderer" in e && (this.options.Renderer = e.Renderer), e.plugins && this.use.apply(this, e.plugins), this;
  }, t.createStyleSheet = function(e, i) {
    i === void 0 && (i = {});
    var o = i, s = o.index;
    typeof s != "number" && (s = Ae.index === 0 ? 0 : Ae.index + 1);
    var a = new nn(e, Y({}, i, {
      jss: this,
      generateId: i.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: s
    }));
    return this.plugins.onProcessSheet(a), a;
  }, t.removeStyleSheet = function(e) {
    return e.detach(), Ae.remove(e), this;
  }, t.createRule = function(e, i, o) {
    if (i === void 0 && (i = {}), o === void 0 && (o = {}), typeof e == "object")
      return this.createRule(void 0, e, i);
    var s = Y({}, o, {
      name: e,
      jss: this,
      Renderer: this.options.Renderer
    });
    s.generateId || (s.generateId = this.generateId), s.classes || (s.classes = {}), s.keyframes || (s.keyframes = {});
    var a = Ke(e, i, s);
    return a && this.plugins.onProcessRule(a), a;
  }, t.use = function() {
    for (var e = this, i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return o.forEach(function(a) {
      e.plugins.use(a);
    }), this;
  }, r;
}(), an = function(t) {
  return new Hi(t);
}, Ir = /* @__PURE__ */ function() {
  function r() {
    this.length = 0, this.sheets = /* @__PURE__ */ new WeakMap();
  }
  var t = r.prototype;
  return t.get = function(e) {
    var i = this.sheets.get(e);
    return i && i.sheet;
  }, t.add = function(e, i) {
    this.sheets.has(e) || (this.length++, this.sheets.set(e, {
      sheet: i,
      refs: 0
    }));
  }, t.manage = function(e) {
    var i = this.sheets.get(e);
    if (i)
      return i.refs === 0 && i.sheet.attach(), i.refs++, i.sheet;
    H(!1, "[JSS] SheetsManager: can't find sheet to manage");
  }, t.unmanage = function(e) {
    var i = this.sheets.get(e);
    i ? i.refs > 0 && (i.refs--, i.refs === 0 && i.sheet.detach()) : H(!1, "SheetsManager: can't find sheet to unmanage");
  }, Gt(r, [{
    key: "size",
    get: function() {
      return this.length;
    }
  }]), r;
}(), Bt = typeof CSS == "object" && CSS != null && "number" in CSS;
function un(r) {
  var t = null;
  for (var n in r) {
    var e = r[n], i = typeof e;
    if (i === "function")
      t || (t = {}), t[n] = e;
    else if (i === "object" && e !== null && !Array.isArray(e)) {
      var o = un(e);
      o && (t || (t = {}), t[n] = o);
    }
  }
  return t;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
an();
var fn = Date.now(), dt = "fnValues" + fn, ht = "fnStyle" + ++fn, Ki = function() {
  return {
    onCreateRule: function(n, e, i) {
      if (typeof e != "function")
        return null;
      var o = Ke(n, {}, i);
      return o[ht] = e, o;
    },
    onProcessStyle: function(n, e) {
      if (dt in e || ht in e)
        return n;
      var i = {};
      for (var o in n) {
        var s = n[o];
        typeof s == "function" && (delete n[o], i[o] = s);
      }
      return e[dt] = i, n;
    },
    onUpdate: function(n, e, i, o) {
      var s = e, a = s[ht];
      if (a && (s.style = a(n) || {}, process.env.NODE_ENV === "development")) {
        for (var u in s.style)
          if (typeof s.style[u] == "function") {
            process.env.NODE_ENV !== "production" && H(!1, "[JSS] Function values inside function rules are not supported.");
            break;
          }
      }
      var f = s[dt];
      if (f)
        for (var l in f)
          s.prop(l, f[l](n), o);
    }
  };
};
function Xi(r) {
  var t, n = r.Symbol;
  return typeof n == "function" ? n.observable ? t = n.observable : (t = n("observable"), n.observable = t) : t = "@@observable", t;
}
var Re;
typeof self < "u" ? Re = self : typeof window < "u" ? Re = window : typeof global < "u" ? Re = global : typeof module < "u" ? Re = module : Re = Function("return this")();
var Mr = Xi(Re), Nr = function(t) {
  return t && t[Mr] && t === t[Mr]();
}, Qi = function(t) {
  return {
    onCreateRule: function(e, i, o) {
      if (!Nr(i))
        return null;
      var s = i, a = Ke(e, {}, o);
      return s.subscribe(function(u) {
        for (var f in u)
          a.prop(f, u[f], t);
      }), a;
    },
    onProcessRule: function(e) {
      if (!(e && e.type !== "style")) {
        var i = e, o = i.style, s = function(l) {
          var c = o[l];
          if (!Nr(c))
            return "continue";
          delete o[l], c.subscribe({
            next: function(S) {
              i.prop(l, S, t);
            }
          });
        };
        for (var a in o)
          var u = s(a);
      }
    }
  };
}, Zi = /;\n/, eo = function(t) {
  for (var n = {}, e = t.split(Zi), i = 0; i < e.length; i++) {
    var o = (e[i] || "").trim();
    if (o) {
      var s = o.indexOf(":");
      if (s === -1) {
        process.env.NODE_ENV !== "production" && H(!1, '[JSS] Malformed CSS string "' + o + '"');
        continue;
      }
      var a = o.substr(0, s).trim(), u = o.substr(s + 1).trim();
      n[a] = u;
    }
  }
  return n;
}, to = function(t) {
  typeof t.style == "string" && (t.style = eo(t.style));
};
function ro() {
  return {
    onProcessRule: to
  };
}
var de = "@global", Mt = "@global ", no = /* @__PURE__ */ function() {
  function r(n, e, i) {
    this.type = "global", this.at = de, this.isProcessed = !1, this.key = n, this.options = i, this.rules = new Xe(Y({}, i, {
      parent: this
    }));
    for (var o in e)
      this.rules.add(o, e[o]);
    this.rules.process();
  }
  var t = r.prototype;
  return t.getRule = function(e) {
    return this.rules.get(e);
  }, t.addRule = function(e, i, o) {
    var s = this.rules.add(e, i, o);
    return s && this.options.jss.plugins.onProcessRule(s), s;
  }, t.replaceRule = function(e, i, o) {
    var s = this.rules.replace(e, i, o);
    return s && this.options.jss.plugins.onProcessRule(s), s;
  }, t.indexOf = function(e) {
    return this.rules.indexOf(e);
  }, t.toString = function(e) {
    return this.rules.toString(e);
  }, r;
}(), io = /* @__PURE__ */ function() {
  function r(n, e, i) {
    this.type = "global", this.at = de, this.isProcessed = !1, this.key = n, this.options = i;
    var o = n.substr(Mt.length);
    this.rule = i.jss.createRule(o, e, Y({}, i, {
      parent: this
    }));
  }
  var t = r.prototype;
  return t.toString = function(e) {
    return this.rule ? this.rule.toString(e) : "";
  }, r;
}(), oo = /\s*,\s*/g;
function cn(r, t) {
  for (var n = r.split(oo), e = "", i = 0; i < n.length; i++)
    e += t + " " + n[i].trim(), n[i + 1] && (e += ", ");
  return e;
}
function so(r, t) {
  var n = r.options, e = r.style, i = e ? e[de] : null;
  if (i) {
    for (var o in i)
      t.addRule(o, i[o], Y({}, n, {
        selector: cn(o, r.selector)
      }));
    delete e[de];
  }
}
function ao(r, t) {
  var n = r.options, e = r.style;
  for (var i in e)
    if (!(i[0] !== "@" || i.substr(0, de.length) !== de)) {
      var o = cn(i.substr(de.length), r.selector);
      t.addRule(o, e[i], Y({}, n, {
        selector: o
      })), delete e[i];
    }
}
function uo() {
  function r(n, e, i) {
    if (!n)
      return null;
    if (n === de)
      return new no(n, e, i);
    if (n[0] === "@" && n.substr(0, Mt.length) === Mt)
      return new io(n, e, i);
    var o = i.parent;
    return o && (o.type === "global" || o.options.parent && o.options.parent.type === "global") && (i.scoped = !1), !i.selector && i.scoped === !1 && (i.selector = n), null;
  }
  function t(n, e) {
    n.type !== "style" || !e || (so(n, e), ao(n, e));
  }
  return {
    onCreateRule: r,
    onProcessRule: t
  };
}
var We = function(t) {
  return t && typeof t == "object" && !Array.isArray(t);
}, pt = "extendCurrValue" + Date.now();
function fo(r, t, n, e) {
  var i = typeof r.extend;
  if (i === "string") {
    if (!n)
      return;
    var o = n.getRule(r.extend);
    if (!o)
      return;
    if (o === t) {
      process.env.NODE_ENV !== "production" && H(!1, `[JSS] A rule tries to extend itself 
` + t.toString());
      return;
    }
    var s = o.options.parent;
    if (s) {
      var a = s.rules.raw[r.extend];
      ye(a, t, n, e);
    }
    return;
  }
  if (Array.isArray(r.extend)) {
    for (var u = 0; u < r.extend.length; u++) {
      var f = r.extend[u], l = typeof f == "string" ? Y({}, r, {
        extend: f
      }) : r.extend[u];
      ye(l, t, n, e);
    }
    return;
  }
  for (var c in r.extend) {
    if (c === "extend") {
      ye(r.extend.extend, t, n, e);
      continue;
    }
    if (We(r.extend[c])) {
      c in e || (e[c] = {}), ye(r.extend[c], t, n, e[c]);
      continue;
    }
    e[c] = r.extend[c];
  }
}
function co(r, t, n, e) {
  for (var i in r)
    if (i !== "extend") {
      if (We(e[i]) && We(r[i])) {
        ye(r[i], t, n, e[i]);
        continue;
      }
      if (We(r[i])) {
        e[i] = ye(r[i], t, n);
        continue;
      }
      e[i] = r[i];
    }
}
function ye(r, t, n, e) {
  return e === void 0 && (e = {}), fo(r, t, n, e), co(r, t, n, e), e;
}
function lo() {
  function r(n, e, i) {
    return "extend" in n ? ye(n, e, i) : n;
  }
  function t(n, e, i) {
    if (e !== "extend")
      return n;
    if (n == null || n === !1) {
      for (var o in i[pt])
        i.prop(o, null);
      return i[pt] = null, null;
    }
    if (typeof n == "object") {
      for (var s in n)
        i.prop(s, n[s]);
      i[pt] = n;
    }
    return null;
  }
  return {
    onProcessStyle: r,
    onChangeValue: t
  };
}
var Dr = /\s*,\s*/g, ho = /&/g, po = /\$([\w-]+)/g;
function vo() {
  function r(i, o) {
    return function(s, a) {
      var u = i.getRule(a) || o && o.getRule(a);
      return u ? u.selector : (process.env.NODE_ENV !== "production" && H(!1, '[JSS] Could not find the referenced rule "' + a + '" in "' + (i.options.meta || i.toString()) + '".'), a);
    };
  }
  function t(i, o) {
    for (var s = o.split(Dr), a = i.split(Dr), u = "", f = 0; f < s.length; f++)
      for (var l = s[f], c = 0; c < a.length; c++) {
        var g = a[c];
        u && (u += ", "), u += g.indexOf("&") !== -1 ? g.replace(ho, l) : l + " " + g;
      }
    return u;
  }
  function n(i, o, s) {
    if (s)
      return Y({}, s, {
        index: s.index + 1
      });
    var a = i.options.nestingLevel;
    a = a === void 0 ? 1 : a + 1;
    var u = Y({}, i.options, {
      nestingLevel: a,
      index: o.indexOf(i) + 1
      // We don't need the parent name to be set options for chlid.
    });
    return delete u.name, u;
  }
  function e(i, o, s) {
    if (o.type !== "style")
      return i;
    var a = o, u = a.options.parent, f, l;
    for (var c in i) {
      var g = c.indexOf("&") !== -1, S = c[0] === "@";
      if (!(!g && !S)) {
        if (f = n(a, u, f), g) {
          var v = t(c, a.selector);
          l || (l = r(u, s)), v = v.replace(po, l);
          var p = a.key + "-" + c;
          "replaceRule" in u ? u.replaceRule(p, i[c], Y({}, f, {
            selector: v
          })) : u.addRule(p, i[c], Y({}, f, {
            selector: v
          }));
        } else
          S && u.addRule(c, {}, f).addRule(a.key, i[c], {
            selector: a.selector
          });
        delete i[c];
      }
    }
    return i;
  }
  return {
    onProcessStyle: e
  };
}
function Nt(r, t) {
  if (!t)
    return !0;
  if (Array.isArray(t)) {
    for (var n = 0; n < t.length; n++) {
      var e = Nt(r, t[n]);
      if (!e)
        return !1;
    }
    return !0;
  }
  if (t.indexOf(" ") > -1)
    return Nt(r, t.split(" "));
  var i = r.options.parent;
  if (t[0] === "$") {
    var o = i.getRule(t.substr(1));
    return o ? o === r ? (process.env.NODE_ENV !== "production" && H(!1, `[JSS] Cyclic composition detected. 
` + r.toString()), !1) : (i.classes[r.key] += " " + i.classes[o.key], !0) : (process.env.NODE_ENV !== "production" && H(!1, `[JSS] Referenced rule is not defined. 
` + r.toString()), !1);
  }
  return i.classes[r.key] += " " + t, !0;
}
function go() {
  function r(t, n) {
    return "composes" in t && (Nt(n, t.composes), delete t.composes), t;
  }
  return {
    onProcessStyle: r
  };
}
var yo = /[A-Z]/g, mo = /^ms-/, vt = {};
function bo(r) {
  return "-" + r.toLowerCase();
}
function ln(r) {
  if (vt.hasOwnProperty(r))
    return vt[r];
  var t = r.replace(yo, bo);
  return vt[r] = mo.test(t) ? "-" + t : t;
}
function Ye(r) {
  var t = {};
  for (var n in r) {
    var e = n.indexOf("--") === 0 ? n : ln(n);
    t[e] = r[n];
  }
  return r.fallbacks && (Array.isArray(r.fallbacks) ? t.fallbacks = r.fallbacks.map(Ye) : t.fallbacks = Ye(r.fallbacks)), t;
}
function So() {
  function r(n) {
    if (Array.isArray(n)) {
      for (var e = 0; e < n.length; e++)
        n[e] = Ye(n[e]);
      return n;
    }
    return Ye(n);
  }
  function t(n, e, i) {
    if (e.indexOf("--") === 0)
      return n;
    var o = ln(e);
    return e === o ? n : (i.prop(o, n), null);
  }
  return {
    onProcessStyle: r,
    onChangeValue: t
  };
}
var h = Bt && CSS ? CSS.px : "px", qe = Bt && CSS ? CSS.ms : "ms", Se = Bt && CSS ? CSS.percent : "%", xo = {
  // Animation properties
  "animation-delay": qe,
  "animation-duration": qe,
  // Background properties
  "background-position": h,
  "background-position-x": h,
  "background-position-y": h,
  "background-size": h,
  // Border Properties
  border: h,
  "border-bottom": h,
  "border-bottom-left-radius": h,
  "border-bottom-right-radius": h,
  "border-bottom-width": h,
  "border-left": h,
  "border-left-width": h,
  "border-radius": h,
  "border-right": h,
  "border-right-width": h,
  "border-top": h,
  "border-top-left-radius": h,
  "border-top-right-radius": h,
  "border-top-width": h,
  "border-width": h,
  "border-block": h,
  "border-block-end": h,
  "border-block-end-width": h,
  "border-block-start": h,
  "border-block-start-width": h,
  "border-block-width": h,
  "border-inline": h,
  "border-inline-end": h,
  "border-inline-end-width": h,
  "border-inline-start": h,
  "border-inline-start-width": h,
  "border-inline-width": h,
  "border-start-start-radius": h,
  "border-start-end-radius": h,
  "border-end-start-radius": h,
  "border-end-end-radius": h,
  // Margin properties
  margin: h,
  "margin-bottom": h,
  "margin-left": h,
  "margin-right": h,
  "margin-top": h,
  "margin-block": h,
  "margin-block-end": h,
  "margin-block-start": h,
  "margin-inline": h,
  "margin-inline-end": h,
  "margin-inline-start": h,
  // Padding properties
  padding: h,
  "padding-bottom": h,
  "padding-left": h,
  "padding-right": h,
  "padding-top": h,
  "padding-block": h,
  "padding-block-end": h,
  "padding-block-start": h,
  "padding-inline": h,
  "padding-inline-end": h,
  "padding-inline-start": h,
  // Mask properties
  "mask-position-x": h,
  "mask-position-y": h,
  "mask-size": h,
  // Width and height properties
  height: h,
  width: h,
  "min-height": h,
  "max-height": h,
  "min-width": h,
  "max-width": h,
  // Position properties
  bottom: h,
  left: h,
  top: h,
  right: h,
  inset: h,
  "inset-block": h,
  "inset-block-end": h,
  "inset-block-start": h,
  "inset-inline": h,
  "inset-inline-end": h,
  "inset-inline-start": h,
  // Shadow properties
  "box-shadow": h,
  "text-shadow": h,
  // Column properties
  "column-gap": h,
  "column-rule": h,
  "column-rule-width": h,
  "column-width": h,
  // Font and text properties
  "font-size": h,
  "font-size-delta": h,
  "letter-spacing": h,
  "text-decoration-thickness": h,
  "text-indent": h,
  "text-stroke": h,
  "text-stroke-width": h,
  "word-spacing": h,
  // Motion properties
  motion: h,
  "motion-offset": h,
  // Outline properties
  outline: h,
  "outline-offset": h,
  "outline-width": h,
  // Perspective properties
  perspective: h,
  "perspective-origin-x": Se,
  "perspective-origin-y": Se,
  // Transform properties
  "transform-origin": Se,
  "transform-origin-x": Se,
  "transform-origin-y": Se,
  "transform-origin-z": Se,
  // Transition properties
  "transition-delay": qe,
  "transition-duration": qe,
  // Alignment properties
  "vertical-align": h,
  "flex-basis": h,
  // Some random properties
  "shape-margin": h,
  size: h,
  gap: h,
  // Grid properties
  grid: h,
  "grid-gap": h,
  "row-gap": h,
  "grid-row-gap": h,
  "grid-column-gap": h,
  "grid-template-rows": h,
  "grid-template-columns": h,
  "grid-auto-rows": h,
  "grid-auto-columns": h,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  "box-shadow-x": h,
  "box-shadow-y": h,
  "box-shadow-blur": h,
  "box-shadow-spread": h,
  "font-line-height": h,
  "text-shadow-x": h,
  "text-shadow-y": h,
  "text-shadow-blur": h
};
function dn(r) {
  var t = /(-[a-z])/g, n = function(s) {
    return s[1].toUpperCase();
  }, e = {};
  for (var i in r)
    e[i] = r[i], e[i.replace(t, n)] = r[i];
  return e;
}
var Ro = dn(xo);
function ke(r, t, n) {
  if (t == null)
    return t;
  if (Array.isArray(t))
    for (var e = 0; e < t.length; e++)
      t[e] = ke(r, t[e], n);
  else if (typeof t == "object")
    if (r === "fallbacks")
      for (var i in t)
        t[i] = ke(i, t[i], n);
    else
      for (var o in t)
        t[o] = ke(r + "-" + o, t[o], n);
  else if (typeof t == "number" && isNaN(t) === !1) {
    var s = n[r] || Ro[r];
    return s && !(t === 0 && s === h) ? typeof s == "function" ? s(t).toString() : "" + t + s : t.toString();
  }
  return t;
}
function Po(r) {
  r === void 0 && (r = {});
  var t = dn(r);
  function n(i, o) {
    if (o.type !== "style")
      return i;
    for (var s in i)
      i[s] = ke(s, i[s], t);
    return i;
  }
  function e(i, o) {
    return ke(o, i, t);
  }
  return {
    onProcessStyle: n,
    onChangeValue: e
  };
}
var wo = {
  "background-size": !0,
  "background-position": !0,
  border: !0,
  "border-bottom": !0,
  "border-left": !0,
  "border-top": !0,
  "border-right": !0,
  "border-radius": !0,
  "border-image": !0,
  "border-width": !0,
  "border-style": !0,
  "border-color": !0,
  "box-shadow": !0,
  flex: !0,
  margin: !0,
  padding: !0,
  outline: !0,
  "transform-origin": !0,
  transform: !0,
  transition: !0
  /**
   * A scheme for converting arrays to regular styles inside of objects.
   * For e.g.: "{position: [0, 0]}" => "background-position: 0 0;".
   */
}, Eo = {
  position: !0,
  // background-position
  size: !0
  // background-size
  /**
   * A scheme for parsing and building correct styles from passed objects.
   */
}, Ue = {
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  background: {
    attachment: null,
    color: null,
    image: null,
    position: null,
    repeat: null
  },
  border: {
    width: null,
    style: null,
    color: null
  },
  "border-top": {
    width: null,
    style: null,
    color: null
  },
  "border-right": {
    width: null,
    style: null,
    color: null
  },
  "border-bottom": {
    width: null,
    style: null,
    color: null
  },
  "border-left": {
    width: null,
    style: null,
    color: null
  },
  outline: {
    width: null,
    style: null,
    color: null
  },
  "list-style": {
    type: null,
    position: null,
    image: null
  },
  transition: {
    property: null,
    duration: null,
    "timing-function": null,
    timingFunction: null,
    // Needed for avoiding comilation issues with jss-plugin-camel-case
    delay: null
  },
  animation: {
    name: null,
    duration: null,
    "timing-function": null,
    timingFunction: null,
    // Needed to avoid compilation issues with jss-plugin-camel-case
    delay: null,
    "iteration-count": null,
    iterationCount: null,
    // Needed to avoid compilation issues with jss-plugin-camel-case
    direction: null,
    "fill-mode": null,
    fillMode: null,
    // Needed to avoid compilation issues with jss-plugin-camel-case
    "play-state": null,
    playState: null
    // Needed to avoid compilation issues with jss-plugin-camel-case
  },
  "box-shadow": {
    x: 0,
    y: 0,
    blur: 0,
    spread: 0,
    color: null,
    inset: null
  },
  "text-shadow": {
    x: 0,
    y: 0,
    blur: null,
    color: null
  }
  /**
   * A scheme for converting non-standart properties inside object.
   * For e.g.: include 'border-radius' property inside 'border' object.
   */
}, gt = {
  border: {
    radius: "border-radius",
    image: "border-image",
    width: "border-width",
    style: "border-style",
    color: "border-color"
  },
  "border-bottom": {
    width: "border-bottom-width",
    style: "border-bottom-style",
    color: "border-bottom-color"
  },
  "border-top": {
    width: "border-top-width",
    style: "border-top-style",
    color: "border-top-color"
  },
  "border-left": {
    width: "border-left-width",
    style: "border-left-style",
    color: "border-left-color"
  },
  "border-right": {
    width: "border-right-width",
    style: "border-right-style",
    color: "border-right-color"
  },
  background: {
    size: "background-size",
    image: "background-image"
  },
  font: {
    style: "font-style",
    variant: "font-variant",
    weight: "font-weight",
    stretch: "font-stretch",
    size: "font-size",
    family: "font-family",
    lineHeight: "line-height",
    // Needed to avoid compilation issues with jss-plugin-camel-case
    "line-height": "line-height"
  },
  flex: {
    grow: "flex-grow",
    basis: "flex-basis",
    direction: "flex-direction",
    wrap: "flex-wrap",
    flow: "flex-flow",
    shrink: "flex-shrink"
  },
  align: {
    self: "align-self",
    items: "align-items",
    content: "align-content"
  },
  grid: {
    "template-columns": "grid-template-columns",
    templateColumns: "grid-template-columns",
    "template-rows": "grid-template-rows",
    templateRows: "grid-template-rows",
    "template-areas": "grid-template-areas",
    templateAreas: "grid-template-areas",
    template: "grid-template",
    "auto-columns": "grid-auto-columns",
    autoColumns: "grid-auto-columns",
    "auto-rows": "grid-auto-rows",
    autoRows: "grid-auto-rows",
    "auto-flow": "grid-auto-flow",
    autoFlow: "grid-auto-flow",
    row: "grid-row",
    column: "grid-column",
    "row-start": "grid-row-start",
    rowStart: "grid-row-start",
    "row-end": "grid-row-end",
    rowEnd: "grid-row-end",
    "column-start": "grid-column-start",
    columnStart: "grid-column-start",
    "column-end": "grid-column-end",
    columnEnd: "grid-column-end",
    area: "grid-area",
    gap: "grid-gap",
    "row-gap": "grid-row-gap",
    rowGap: "grid-row-gap",
    "column-gap": "grid-column-gap",
    columnGap: "grid-column-gap"
  }
};
function Oo(r, t, n) {
  return r.map(function(e) {
    return pn(e, t, n, !1, !0);
  });
}
function hn(r, t, n, e) {
  return n[t] == null ? r : r.length === 0 ? [] : Array.isArray(r[0]) ? hn(r[0], t, n, e) : typeof r[0] == "object" ? Oo(r, t, e) : [r];
}
function pn(r, t, n, e, i) {
  if (!(Ue[t] || gt[t]))
    return [];
  var o = [];
  if (gt[t] && (r = To(r, n, gt[t], e)), Object.keys(r).length)
    for (var s in Ue[t]) {
      if (r[s]) {
        Array.isArray(r[s]) ? o.push(Eo[s] === null ? r[s] : r[s].join(" ")) : o.push(r[s]);
        continue;
      }
      Ue[t][s] != null && o.push(Ue[t][s]);
    }
  return !o.length || i ? o : [o];
}
function To(r, t, n, e) {
  for (var i in n) {
    var o = n[i];
    if (typeof r[i] < "u" && (e || !t.prop(o))) {
      var s, a = Me((s = {}, s[o] = r[i], s), t)[o];
      e ? t.style.fallbacks[o] = a : t.style[o] = a;
    }
    delete r[i];
  }
  return r;
}
function Me(r, t, n) {
  for (var e in r) {
    var i = r[e];
    if (Array.isArray(i)) {
      if (!Array.isArray(i[0])) {
        if (e === "fallbacks") {
          for (var o = 0; o < r.fallbacks.length; o++)
            r.fallbacks[o] = Me(r.fallbacks[o], t, !0);
          continue;
        }
        r[e] = hn(i, e, wo, t), r[e].length || delete r[e];
      }
    } else if (typeof i == "object") {
      if (e === "fallbacks") {
        r.fallbacks = Me(r.fallbacks, t, !0);
        continue;
      }
      r[e] = pn(i, e, t, n), r[e].length || delete r[e];
    } else
      r[e] === "" && delete r[e];
  }
  return r;
}
function Co() {
  function r(t, n) {
    if (!t || n.type !== "style")
      return t;
    if (Array.isArray(t)) {
      for (var e = 0; e < t.length; e++)
        t[e] = Me(t[e], n);
      return t;
    }
    return Me(t, n);
  }
  return {
    onProcessStyle: r
  };
}
function Dt(r, t) {
  (t == null || t > r.length) && (t = r.length);
  for (var n = 0, e = new Array(t); n < t; n++)
    e[n] = r[n];
  return e;
}
function Ao(r) {
  if (Array.isArray(r))
    return Dt(r);
}
function ko(r) {
  if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null)
    return Array.from(r);
}
function jo(r, t) {
  if (r) {
    if (typeof r == "string")
      return Dt(r, t);
    var n = Object.prototype.toString.call(r).slice(8, -1);
    if (n === "Object" && r.constructor && (n = r.constructor.name), n === "Map" || n === "Set")
      return Array.from(r);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Dt(r, t);
  }
}
function _o() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Io(r) {
  return Ao(r) || ko(r) || jo(r) || _o();
}
var Te = "", Vt = "", vn = "", gn = "", Mo = we && "ontouchstart" in document.documentElement;
if (we) {
  var yt = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  }, No = document.createElement("p"), mt = No.style, Do = "Transform";
  for (var bt in yt)
    if (bt + Do in mt) {
      Te = bt, Vt = yt[bt];
      break;
    }
  Te === "Webkit" && "msHyphens" in mt && (Te = "ms", Vt = yt.ms, gn = "edge"), Te === "Webkit" && "-apple-trailing-word" in mt && (vn = "apple");
}
var M = {
  js: Te,
  css: Vt,
  vendor: vn,
  browser: gn,
  isTouch: Mo
};
function Vo(r) {
  return r[1] === "-" || M.js === "ms" ? r : "@" + M.css + "keyframes" + r.substr(10);
}
var $o = {
  noPrefill: ["appearance"],
  supportedProperty: function(t) {
    return t !== "appearance" ? !1 : M.js === "ms" ? "-webkit-" + t : M.css + t;
  }
}, Lo = {
  noPrefill: ["color-adjust"],
  supportedProperty: function(t) {
    return t !== "color-adjust" ? !1 : M.js === "Webkit" ? M.css + "print-" + t : t;
  }
}, Fo = /[-\s]+(.)?/g;
function zo(r, t) {
  return t ? t.toUpperCase() : "";
}
function Yt(r) {
  return r.replace(Fo, zo);
}
function he(r) {
  return Yt("-" + r);
}
var qo = {
  noPrefill: ["mask"],
  supportedProperty: function(t, n) {
    if (!/^mask/.test(t))
      return !1;
    if (M.js === "Webkit") {
      var e = "mask-image";
      if (Yt(e) in n)
        return t;
      if (M.js + he(e) in n)
        return M.css + t;
    }
    return t;
  }
}, Uo = {
  noPrefill: ["text-orientation"],
  supportedProperty: function(t) {
    return t !== "text-orientation" ? !1 : M.vendor === "apple" && !M.isTouch ? M.css + t : t;
  }
}, Wo = {
  noPrefill: ["transform"],
  supportedProperty: function(t, n, e) {
    return t !== "transform" ? !1 : e.transform ? t : M.css + t;
  }
}, Go = {
  noPrefill: ["transition"],
  supportedProperty: function(t, n, e) {
    return t !== "transition" ? !1 : e.transition ? t : M.css + t;
  }
}, Jo = {
  noPrefill: ["writing-mode"],
  supportedProperty: function(t) {
    return t !== "writing-mode" ? !1 : M.js === "Webkit" || M.js === "ms" && M.browser !== "edge" ? M.css + t : t;
  }
}, Bo = {
  noPrefill: ["user-select"],
  supportedProperty: function(t) {
    return t !== "user-select" ? !1 : M.js === "Moz" || M.js === "ms" || M.vendor === "apple" ? M.css + t : t;
  }
}, Yo = {
  supportedProperty: function(t, n) {
    if (!/^break-/.test(t))
      return !1;
    if (M.js === "Webkit") {
      var e = "WebkitColumn" + he(t);
      return e in n ? M.css + "column-" + t : !1;
    }
    if (M.js === "Moz") {
      var i = "page" + he(t);
      return i in n ? "page-" + t : !1;
    }
    return !1;
  }
}, Ho = {
  supportedProperty: function(t, n) {
    if (!/^(border|margin|padding)-inline/.test(t))
      return !1;
    if (M.js === "Moz")
      return t;
    var e = t.replace("-inline", "");
    return M.js + he(e) in n ? M.css + e : !1;
  }
}, Ko = {
  supportedProperty: function(t, n) {
    return Yt(t) in n ? t : !1;
  }
}, Xo = {
  supportedProperty: function(t, n) {
    var e = he(t);
    return t[0] === "-" || t[0] === "-" && t[1] === "-" ? t : M.js + e in n ? M.css + t : M.js !== "Webkit" && "Webkit" + e in n ? "-webkit-" + t : !1;
  }
}, Qo = {
  supportedProperty: function(t) {
    return t.substring(0, 11) !== "scroll-snap" ? !1 : M.js === "ms" ? "" + M.css + t : t;
  }
}, Zo = {
  supportedProperty: function(t) {
    return t !== "overscroll-behavior" ? !1 : M.js === "ms" ? M.css + "scroll-chaining" : t;
  }
}, es = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
  // 'align-self' is handled by 'align-self' plugin.
}, ts = {
  supportedProperty: function(t, n) {
    var e = es[t];
    return e && M.js + he(e) in n ? M.css + e : !1;
  }
}, yn = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
}, rs = Object.keys(yn), ns = function(t) {
  return M.css + t;
}, is = {
  supportedProperty: function(t, n, e) {
    var i = e.multiple;
    if (rs.indexOf(t) > -1) {
      var o = yn[t];
      if (!Array.isArray(o))
        return M.js + he(o) in n ? M.css + o : !1;
      if (!i)
        return !1;
      for (var s = 0; s < o.length; s++)
        if (!(M.js + he(o[0]) in n))
          return !1;
      return o.map(ns);
    }
    return !1;
  }
}, mn = [$o, Lo, qo, Uo, Wo, Go, Jo, Bo, Yo, Ho, Ko, Xo, Qo, Zo, ts, is], Vr = mn.filter(function(r) {
  return r.supportedProperty;
}).map(function(r) {
  return r.supportedProperty;
}), os = mn.filter(function(r) {
  return r.noPrefill;
}).reduce(function(r, t) {
  return r.push.apply(r, Io(t.noPrefill)), r;
}, []), Ce, ge = {};
if (we) {
  Ce = document.createElement("p");
  var St = window.getComputedStyle(document.documentElement, "");
  for (var xt in St)
    isNaN(xt) || (ge[St[xt]] = St[xt]);
  os.forEach(function(r) {
    return delete ge[r];
  });
}
function $t(r, t) {
  if (t === void 0 && (t = {}), !Ce)
    return r;
  if (process.env.NODE_ENV !== "benchmark" && ge[r] != null)
    return ge[r];
  (r === "transition" || r === "transform") && (t[r] = r in Ce.style);
  for (var n = 0; n < Vr.length && (ge[r] = Vr[n](r, Ce.style, t), !ge[r]); n++)
    ;
  try {
    Ce.style[r] = "";
  } catch {
    return !1;
  }
  return ge[r];
}
var xe = {}, ss = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
}, as = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g, ce;
function us(r, t, n) {
  if (t === "var")
    return "var";
  if (t === "all")
    return "all";
  if (n === "all")
    return ", all";
  var e = t ? $t(t) : ", " + $t(n);
  return e || t || n;
}
we && (ce = document.createElement("p"));
function $r(r, t) {
  var n = t;
  if (!ce || r === "content")
    return t;
  if (typeof n != "string" || !isNaN(parseInt(n, 10)))
    return n;
  var e = r + n;
  if (process.env.NODE_ENV !== "benchmark" && xe[e] != null)
    return xe[e];
  try {
    ce.style[r] = n;
  } catch {
    return xe[e] = !1, !1;
  }
  if (ss[r])
    n = n.replace(as, us);
  else if (ce.style[r] === "" && (n = M.css + n, n === "-ms-flex" && (ce.style[r] = "-ms-flexbox"), ce.style[r] = n, ce.style[r] === ""))
    return xe[e] = !1, !1;
  return ce.style[r] = "", xe[e] = n, xe[e];
}
function fs() {
  function r(i) {
    if (i.type === "keyframes") {
      var o = i;
      o.at = Vo(o.at);
    }
  }
  function t(i) {
    for (var o in i) {
      var s = i[o];
      if (o === "fallbacks" && Array.isArray(s)) {
        i[o] = s.map(t);
        continue;
      }
      var a = !1, u = $t(o);
      u && u !== o && (a = !0);
      var f = !1, l = $r(u, me(s));
      l && l !== s && (f = !0), (a || f) && (a && delete i[o], i[u || o] = l || s);
    }
    return i;
  }
  function n(i, o) {
    return o.type !== "style" ? i : t(i);
  }
  function e(i, o) {
    return $r(o, me(i)) || i;
  }
  return {
    onProcessRule: r,
    onProcessStyle: n,
    onChangeValue: e
  };
}
function cs() {
  var r = function(n, e) {
    return n.length === e.length ? n > e ? 1 : -1 : n.length - e.length;
  };
  return {
    onProcessStyle: function(n, e) {
      if (e.type !== "style")
        return n;
      for (var i = {}, o = Object.keys(n).sort(r), s = 0; s < o.length; s++)
        i[o[s]] = n[o[s]];
      return i;
    }
  };
}
var ls = function(t) {
  return t === void 0 && (t = {}), {
    plugins: [Ki(), Qi(t.observable), ro(), uo(), lo(), vo(), go(), So(), Po(t.defaultUnit), Co(), fs(), cs()]
  };
}, ds = Number.MIN_SAFE_INTEGER || -1e9, hs = function() {
  return ds++;
}, ps = Yr({
  classNamePrefix: "",
  disableStylesGeneration: !1,
  isSSR: !we
}), Lr = /* @__PURE__ */ new Map(), Ht = function(t, n) {
  var e = t.managers;
  if (e)
    return e[n] || (e[n] = new Ir()), e[n];
  var i = Lr.get(n);
  return i || (i = new Ir(), Lr.set(n, i)), i;
}, Fr = function(t) {
  var n = t.sheet, e = t.context, i = t.index, o = t.theme;
  if (n) {
    var s = Ht(e, i);
    s.manage(o), e.registry && e.registry.add(n);
  }
}, vs = function(t) {
  if (t.sheet) {
    var n = Ht(t.context, t.index);
    n.unmanage(t.theme);
  }
}, gs = an(ls()), bn = /* @__PURE__ */ new WeakMap(), Sn = function(t) {
  return bn.get(t);
}, ys = function(t, n) {
  bn.set(t, n);
}, ms = function(t) {
  var n = t.styles;
  return typeof n != "function" ? n : (process.env.NODE_ENV !== "production" && H(n.length !== 0, "[JSS] <" + (t.name || "Hook") + ` />'s styles function doesn't rely on the "theme" argument. We recommend declaring styles as an object instead.`), n(t.theme));
};
function bs(r, t) {
  var n;
  r.context.id && r.context.id.minify != null && (n = r.context.id.minify);
  var e = r.context.classNamePrefix || "";
  r.name && !n && (e += r.name.replace(/\s/g, "-") + "-");
  var i = "";
  return r.name && (i = r.name + ", "), i += typeof r.styles == "function" ? "Themed" : "Unthemed", Y({}, r.sheetOptions, {
    index: r.index,
    meta: i,
    classNamePrefix: e,
    link: t,
    generateId: r.sheetOptions && r.sheetOptions.generateId ? r.sheetOptions.generateId : r.context.generateId
  });
}
var Ss = function(t) {
  if (!t.context.disableStylesGeneration) {
    var n = Ht(t.context, t.index), e = n.get(t.theme);
    if (e)
      return e;
    var i = t.context.jss || gs, o = ms(t), s = un(o), a = i.createStyleSheet(o, bs(t, s !== null));
    return ys(a, {
      dynamicStyles: s,
      styles: o
    }), n.add(t.theme, a), a;
  }
}, xs = function(t, n) {
  for (var e in n)
    t.deleteRule(n[e]);
}, Rs = function(t, n, e) {
  for (var i in e)
    n.updateOne(e[i], t);
}, Ps = function(t, n) {
  var e = Sn(t);
  if (e) {
    var i = {};
    for (var o in e.dynamicStyles)
      for (var s = t.rules.index.length, a = t.addRule(o, e.dynamicStyles[o]), u = s; u < t.rules.index.length; u++) {
        var f = t.rules.index[u];
        t.updateOne(f, n), i[a === f ? o : f.key] = f;
      }
    return i;
  }
}, ws = function(t, n) {
  if (!n)
    return t.classes;
  var e = Sn(t);
  if (!e)
    return t.classes;
  var i = {};
  for (var o in e.styles)
    i[o] = t.classes[o], o in n && (i[o] += " " + t.classes[n[o].key]);
  return i;
};
function zr(r) {
  return r ? Pe : le.useInsertionEffect || // React 18+ (https://github.com/reactwg/react-18/discussions/110)
  Mn;
}
var Rt = {}, Es = function(t, n) {
  n === void 0 && (n = {});
  var e = n, i = e.index, o = i === void 0 ? hs() : i, s = e.theming, a = e.name, u = Hr(e, ["index", "theming", "name"]), f = s && s.context || en, l = function(S) {
    return typeof t == "function" && (S || ur(f)) || Rt;
  }, c = {};
  return function(S) {
    var v = Pt(!0), p = ur(ps), x = l(S && S.theme), y = wt(function() {
      var m = Ss({
        context: p,
        styles: t,
        name: a,
        theme: x,
        index: o,
        sheetOptions: u
      });
      return m && p.isSSR && Fr({
        index: o,
        context: p,
        sheet: m,
        theme: x
      }), [m, m ? Ps(m, S) : null];
    }, [p, x]), R = y[0], P = y[1];
    zr(p.isSSR)(function() {
      R && P && !v.current && Rs(S, R, P);
    }, [S]), zr(p.isSSR)(function() {
      return R && Fr({
        index: o,
        context: p,
        sheet: R,
        theme: x
      }), function() {
        R && (vs({
          index: o,
          context: p,
          sheet: R,
          theme: x
        }), P && xs(R, P));
      };
    }, [R]);
    var E = wt(function() {
      return R && P ? ws(R, P) : c;
    }, [R, P]);
    return fr(E), fr(x === Rt ? "No theme" : x), Pe(function() {
      v.current = !1;
    }), E;
  };
}, xn = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(r) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var o = "", s = 0; s < arguments.length; s++) {
        var a = arguments[s];
        a && (o = i(o, e(a)));
      }
      return o;
    }
    function e(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return n.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var s = "";
      for (var a in o)
        t.call(o, a) && o[a] && (s = i(s, a));
      return s;
    }
    function i(o, s) {
      return s ? o ? o + " " + s : o + s : o;
    }
    r.exports ? (n.default = n, r.exports = n) : window.classNames = n;
  })();
})(xn);
var Os = xn.exports;
const qr = /* @__PURE__ */ Ft(Os);
function Ts(r) {
  return Object.prototype.toString.call(r) === "[object Object]";
}
function Ur(r) {
  return Ts(r) || Array.isArray(r);
}
function Cs() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Kt(r, t) {
  const n = Object.keys(r), e = Object.keys(t);
  if (n.length !== e.length)
    return !1;
  const i = JSON.stringify(Object.keys(r.breakpoints || {})), o = JSON.stringify(Object.keys(t.breakpoints || {}));
  return i !== o ? !1 : n.every((s) => {
    const a = r[s], u = t[s];
    return typeof a == "function" ? `${a}` == `${u}` : !Ur(a) || !Ur(u) ? a === u : Kt(a, u);
  });
}
function Wr(r) {
  return r.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function As(r, t) {
  if (r.length !== t.length)
    return !1;
  const n = Wr(r), e = Wr(t);
  return n.every((i, o) => {
    const s = e[o];
    return Kt(i, s);
  });
}
function Xt(r) {
  return typeof r == "number";
}
function Lt(r) {
  return typeof r == "string";
}
function Qt(r) {
  return typeof r == "boolean";
}
function Gr(r) {
  return Object.prototype.toString.call(r) === "[object Object]";
}
function B(r) {
  return Math.abs(r);
}
function Zt(r) {
  return Math.sign(r);
}
function je(r, t) {
  return B(r - t);
}
function ks(r, t) {
  if (r === 0 || t === 0 || B(r) <= B(t))
    return 0;
  const n = je(B(r), B(t));
  return B(n / r);
}
function Ne(r) {
  return De(r).map(Number);
}
function se(r) {
  return r[$e(r)];
}
function $e(r) {
  return Math.max(0, r.length - 1);
}
function er(r, t) {
  return t === $e(r);
}
function Jr(r, t = 0) {
  return Array.from(Array(r), (n, e) => t + e);
}
function De(r) {
  return Object.keys(r);
}
function Rn(r, t) {
  return [r, t].reduce((n, e) => (De(e).forEach((i) => {
    const o = n[i], s = e[i], a = Gr(o) && Gr(s);
    n[i] = a ? Rn(o, s) : s;
  }), n), {});
}
function Pn(r, t) {
  return typeof t.MouseEvent < "u" && r instanceof t.MouseEvent;
}
function js(r, t) {
  const n = {
    start: e,
    center: i,
    end: o
  };
  function e() {
    return 0;
  }
  function i(u) {
    return o(u) / 2;
  }
  function o(u) {
    return t - u;
  }
  function s(u, f) {
    return Lt(r) ? n[r](u) : r(t, u, f);
  }
  return {
    measure: s
  };
}
function Ve() {
  let r = [];
  function t(i, o, s, a = {
    passive: !0
  }) {
    let u;
    if ("addEventListener" in i)
      i.addEventListener(o, s, a), u = () => i.removeEventListener(o, s, a);
    else {
      const f = i;
      f.addListener(s), u = () => f.removeListener(s);
    }
    return r.push(u), e;
  }
  function n() {
    r = r.filter((i) => i());
  }
  const e = {
    add: t,
    clear: n
  };
  return e;
}
function _s(r, t, n, e) {
  const i = Ve(), o = 1e3 / 60;
  let s = null, a = 0, u = 0;
  function f() {
    i.add(r, "visibilitychange", () => {
      r.hidden && v();
    });
  }
  function l() {
    S(), i.clear();
  }
  function c(x) {
    if (!u)
      return;
    s || (s = x);
    const y = x - s;
    for (s = x, a += y; a >= o; )
      n(), a -= o;
    const R = B(a / o);
    e(R), u && t.requestAnimationFrame(c);
  }
  function g() {
    u || (u = t.requestAnimationFrame(c));
  }
  function S() {
    t.cancelAnimationFrame(u), s = null, a = 0, u = 0;
  }
  function v() {
    s = null, a = 0;
  }
  return {
    init: f,
    destroy: l,
    start: g,
    stop: S,
    update: n,
    render: e
  };
}
function Is(r, t) {
  const n = t === "rtl", e = r === "y", i = e ? "y" : "x", o = e ? "x" : "y", s = !e && n ? -1 : 1, a = l(), u = c();
  function f(v) {
    const {
      height: p,
      width: x
    } = v;
    return e ? p : x;
  }
  function l() {
    return e ? "top" : n ? "right" : "left";
  }
  function c() {
    return e ? "bottom" : n ? "left" : "right";
  }
  function g(v) {
    return v * s;
  }
  return {
    scroll: i,
    cross: o,
    startEdge: a,
    endEdge: u,
    measureSize: f,
    direction: g
  };
}
function be(r = 0, t = 0) {
  const n = B(r - t);
  function e(f) {
    return f < r;
  }
  function i(f) {
    return f > t;
  }
  function o(f) {
    return e(f) || i(f);
  }
  function s(f) {
    return o(f) ? e(f) ? r : t : f;
  }
  function a(f) {
    return n ? f - n * Math.ceil((f - t) / n) : f;
  }
  return {
    length: n,
    max: t,
    min: r,
    constrain: s,
    reachedAny: o,
    reachedMax: i,
    reachedMin: e,
    removeOffset: a
  };
}
function wn(r, t, n) {
  const {
    constrain: e
  } = be(0, r), i = r + 1;
  let o = s(t);
  function s(g) {
    return n ? B((i + g) % i) : e(g);
  }
  function a() {
    return o;
  }
  function u(g) {
    return o = s(g), c;
  }
  function f(g) {
    return l().set(a() + g);
  }
  function l() {
    return wn(r, a(), n);
  }
  const c = {
    get: a,
    set: u,
    add: f,
    clone: l
  };
  return c;
}
function Ms(r, t, n, e, i, o, s, a, u, f, l, c, g, S, v, p, x, y, R) {
  const {
    cross: P,
    direction: E
  } = r, m = ["INPUT", "SELECT", "TEXTAREA"], F = {
    passive: !1
  }, _ = Ve(), L = Ve(), z = be(50, 225).constrain(S.measure(20)), q = {
    mouse: 300,
    touch: 400
  }, G = {
    mouse: 500,
    touch: 600
  }, ee = v ? 43 : 25;
  let ie = !1, X = 0, te = 0, Q = !1, Z = !1, re = !1, ne = !1;
  function b(d) {
    if (!R)
      return;
    function N(K) {
      (Qt(R) || R(d, K)) && O(K);
    }
    const J = t;
    _.add(J, "dragstart", (K) => K.preventDefault(), F).add(J, "touchmove", () => {
    }, F).add(J, "touchend", () => {
    }).add(J, "touchstart", N).add(J, "mousedown", N).add(J, "touchcancel", C).add(J, "contextmenu", C).add(J, "click", $, !0);
  }
  function w() {
    _.clear(), L.clear();
  }
  function I() {
    const d = ne ? n : t;
    L.add(d, "touchmove", T, F).add(d, "touchend", C).add(d, "mousemove", T, F).add(d, "mouseup", C);
  }
  function A(d) {
    const N = d.nodeName || "";
    return m.includes(N);
  }
  function k() {
    return (v ? G : q)[ne ? "mouse" : "touch"];
  }
  function D(d, N) {
    const J = c.add(Zt(d) * -1), K = l.byDistance(d, !v).distance;
    return v || B(d) < z ? K : x && N ? K * 0.5 : l.byIndex(J.get(), 0).distance;
  }
  function O(d) {
    const N = Pn(d, e);
    ne = N, re = v && N && !d.buttons && ie, ie = je(i.get(), s.get()) >= 2, !(N && d.button !== 0) && (A(d.target) || (Q = !0, o.pointerDown(d), f.useFriction(0).useDuration(0), i.set(s), I(), X = o.readPoint(d), te = o.readPoint(d, P), g.emit("pointerDown")));
  }
  function T(d) {
    const N = o.readPoint(d), J = o.readPoint(d, P), K = je(N, X), ae = je(J, te);
    if (!Z && !ne && (!d.cancelable || (Z = K > ae, !Z)))
      return C(d);
    const oe = o.pointerMove(d);
    K > p && (re = !0), f.useFriction(0.3).useDuration(1), a.start(), i.add(E(oe)), d.preventDefault();
  }
  function C(d) {
    const J = l.byDistance(0, !1).index !== c.get(), K = o.pointerUp(d) * k(), ae = D(E(K), J), oe = ks(K, ae), ue = ee - 10 * oe, pe = y + oe / 50;
    Z = !1, Q = !1, L.clear(), f.useDuration(ue).useFriction(pe), u.distance(ae, !v), ne = !1, g.emit("pointerUp");
  }
  function $(d) {
    re && (d.stopPropagation(), d.preventDefault(), re = !1);
  }
  function j() {
    return Q;
  }
  return {
    init: b,
    pointerDown: j,
    destroy: w
  };
}
function Ns(r, t) {
  let e, i;
  function o(c) {
    return c.timeStamp;
  }
  function s(c, g) {
    const v = `client${(g || r.scroll) === "x" ? "X" : "Y"}`;
    return (Pn(c, t) ? c : c.touches[0])[v];
  }
  function a(c) {
    return e = c, i = c, s(c);
  }
  function u(c) {
    const g = s(c) - s(i), S = o(c) - o(e) > 170;
    return i = c, S && (e = c), g;
  }
  function f(c) {
    if (!e || !i)
      return 0;
    const g = s(i) - s(e), S = o(c) - o(e), v = o(c) - o(i) > 170, p = g / S;
    return S && !v && B(p) > 0.1 ? p : 0;
  }
  return {
    pointerDown: a,
    pointerMove: u,
    pointerUp: f,
    readPoint: s
  };
}
function Ds() {
  function r(n) {
    const {
      offsetTop: e,
      offsetLeft: i,
      offsetWidth: o,
      offsetHeight: s
    } = n;
    return {
      top: e,
      right: i + o,
      bottom: e + s,
      left: i,
      width: o,
      height: s
    };
  }
  return {
    measure: r
  };
}
function Vs(r) {
  function t(e) {
    return r * (e / 100);
  }
  return {
    measure: t
  };
}
function $s(r, t, n, e, i, o, s) {
  let a, u, f = [], l = !1;
  function c(p) {
    return i.measureSize(s.measure(p));
  }
  function g(p) {
    if (!o)
      return;
    u = c(r), f = e.map(c);
    function x(R) {
      for (const P of R) {
        const E = P.target === r, m = e.indexOf(P.target), F = E ? u : f[m], _ = c(E ? r : e[m]);
        if (B(_ - F) >= 0.5) {
          n.requestAnimationFrame(() => {
            p.reInit(), t.emit("resize");
          });
          break;
        }
      }
    }
    a = new ResizeObserver((R) => {
      l || (Qt(o) || o(p, R)) && x(R);
    }), [r].concat(e).forEach((R) => a.observe(R));
  }
  function S() {
    a && a.disconnect(), l = !0;
  }
  return {
    init: g,
    destroy: S
  };
}
function Ls(r, t, n, e, i) {
  let o = 0, s = 0, a = e, u = i, f = r.get(), l = 0;
  function c() {
    const m = n.get() - r.get(), F = !a;
    let _ = 0;
    return F ? (o = 0, r.set(n), _ = m) : (o += m / a, o *= u, f += o, r.add(o), _ = f - l), s = Zt(_), l = f, E;
  }
  function g() {
    const m = n.get() - t.get();
    return B(m) < 1e-3;
  }
  function S() {
    return a;
  }
  function v() {
    return s;
  }
  function p() {
    return o;
  }
  function x() {
    return R(e);
  }
  function y() {
    return P(i);
  }
  function R(m) {
    return a = m, E;
  }
  function P(m) {
    return u = m, E;
  }
  const E = {
    direction: v,
    duration: S,
    velocity: p,
    seek: c,
    settled: g,
    useBaseFriction: y,
    useBaseDuration: x,
    useFriction: P,
    useDuration: R
  };
  return E;
}
function Fs(r, t, n, e, i) {
  const o = i.measure(10), s = i.measure(50), a = be(0.1, 0.99);
  let u = !1;
  function f() {
    return !(u || !r.reachedAny(n.get()) || !r.reachedAny(t.get()));
  }
  function l(S) {
    if (!f())
      return;
    const v = r.reachedMin(t.get()) ? "min" : "max", p = B(r[v] - t.get()), x = n.get() - t.get(), y = a.constrain(p / s);
    n.subtract(x * y), !S && B(x) < o && (n.set(r.constrain(n.get())), e.useDuration(25).useBaseFriction());
  }
  function c(S) {
    u = !S;
  }
  return {
    constrain: l,
    toggleActive: c
  };
}
function zs(r, t, n, e, i) {
  const o = be(-t + r, 0), s = c(), a = l(), u = g();
  function f(v, p) {
    return je(v, p) < 1;
  }
  function l() {
    const v = s[0], p = se(s), x = s.lastIndexOf(v), y = s.indexOf(p) + 1;
    return be(x, y);
  }
  function c() {
    return n.map((v, p) => {
      const {
        min: x,
        max: y
      } = o, R = o.constrain(v), P = !p, E = er(n, p);
      return P ? y : E || f(x, R) ? x : f(y, R) ? y : R;
    }).map((v) => parseFloat(v.toFixed(3)));
  }
  function g() {
    if (t <= r + i)
      return [o.max];
    if (e === "keepSnaps")
      return s;
    const {
      min: v,
      max: p
    } = a;
    return s.slice(v, p);
  }
  return {
    snapsContained: u,
    scrollContainLimit: a
  };
}
function qs(r, t, n) {
  const e = t[0], i = n ? e - r : se(t);
  return {
    limit: be(i, e)
  };
}
function Us(r, t, n, e) {
  const o = t.min + 0.1, s = t.max + 0.1, {
    reachedMin: a,
    reachedMax: u
  } = be(o, s);
  function f(g) {
    return g === 1 ? u(n.get()) : g === -1 ? a(n.get()) : !1;
  }
  function l(g) {
    if (!f(g))
      return;
    const S = r * (g * -1);
    e.forEach((v) => v.add(S));
  }
  return {
    loop: l
  };
}
function Ws(r) {
  const {
    max: t,
    length: n
  } = r;
  function e(o) {
    const s = o - t;
    return n ? s / -n : 0;
  }
  return {
    get: e
  };
}
function Gs(r, t, n, e, i) {
  const {
    startEdge: o,
    endEdge: s
  } = r, {
    groupSlides: a
  } = i, u = c().map(t.measure), f = g(), l = S();
  function c() {
    return a(e).map((p) => se(p)[s] - p[0][o]).map(B);
  }
  function g() {
    return e.map((p) => n[o] - p[o]).map((p) => -B(p));
  }
  function S() {
    return a(f).map((p) => p[0]).map((p, x) => p + u[x]);
  }
  return {
    snaps: f,
    snapsAligned: l
  };
}
function Js(r, t, n, e, i, o) {
  const {
    groupSlides: s
  } = i, {
    min: a,
    max: u
  } = e, f = l();
  function l() {
    const g = s(o), S = !r || t === "keepSnaps";
    return n.length === 1 ? [o] : S ? g : g.slice(a, u).map((v, p, x) => {
      const y = !p, R = er(x, p);
      if (y) {
        const P = se(x[0]) + 1;
        return Jr(P);
      }
      if (R) {
        const P = $e(o) - se(x)[0] + 1;
        return Jr(P, se(x)[0]);
      }
      return v;
    });
  }
  return {
    slideRegistry: f
  };
}
function Bs(r, t, n, e, i) {
  const {
    reachedAny: o,
    removeOffset: s,
    constrain: a
  } = e;
  function u(v) {
    return v.concat().sort((p, x) => B(p) - B(x))[0];
  }
  function f(v) {
    const p = r ? s(v) : a(v), x = t.map((R, P) => ({
      diff: l(R - p, 0),
      index: P
    })).sort((R, P) => B(R.diff) - B(P.diff)), {
      index: y
    } = x[0];
    return {
      index: y,
      distance: p
    };
  }
  function l(v, p) {
    const x = [v, v + n, v - n];
    if (!r)
      return x[0];
    if (!p)
      return u(x);
    const y = x.filter((R) => Zt(R) === p);
    return y.length ? u(y) : se(x) - n;
  }
  function c(v, p) {
    const x = t[v] - i.get(), y = l(x, p);
    return {
      index: v,
      distance: y
    };
  }
  function g(v, p) {
    const x = i.get() + v, {
      index: y,
      distance: R
    } = f(x), P = !r && o(x);
    if (!p || P)
      return {
        index: y,
        distance: v
      };
    const E = t[y] - R, m = v + l(E, 0);
    return {
      index: y,
      distance: m
    };
  }
  return {
    byDistance: g,
    byIndex: c,
    shortcut: l
  };
}
function Ys(r, t, n, e, i, o, s) {
  function a(c) {
    const g = c.distance, S = c.index !== t.get();
    o.add(g), g && (e.duration() ? r.start() : (r.update(), r.render(1), r.update())), S && (n.set(t.get()), t.set(c.index), s.emit("select"));
  }
  function u(c, g) {
    const S = i.byDistance(c, g);
    a(S);
  }
  function f(c, g) {
    const S = t.clone().set(c), v = i.byIndex(S.get(), g);
    a(v);
  }
  return {
    distance: u,
    index: f
  };
}
function Hs(r, t, n, e, i, o) {
  let s = 0;
  function a() {
    o.add(document, "keydown", u, !1), t.forEach(f);
  }
  function u(c) {
    c.code === "Tab" && (s = (/* @__PURE__ */ new Date()).getTime());
  }
  function f(c) {
    const g = () => {
      if ((/* @__PURE__ */ new Date()).getTime() - s > 10)
        return;
      r.scrollLeft = 0;
      const p = t.indexOf(c), x = n.findIndex((y) => y.includes(p));
      Xt(x) && (i.useDuration(0), e.index(x, 0));
    };
    o.add(c, "focus", g, {
      passive: !0,
      capture: !0
    });
  }
  return {
    init: a
  };
}
function Ge(r) {
  let t = r;
  function n() {
    return t;
  }
  function e(u) {
    t = s(u);
  }
  function i(u) {
    t += s(u);
  }
  function o(u) {
    t -= s(u);
  }
  function s(u) {
    return Xt(u) ? u : u.get();
  }
  return {
    get: n,
    set: e,
    add: i,
    subtract: o
  };
}
function En(r, t) {
  const n = r.scroll === "x" ? o : s, e = t.style;
  let i = !1;
  function o(c) {
    return `translate3d(${c}px,0px,0px)`;
  }
  function s(c) {
    return `translate3d(0px,${c}px,0px)`;
  }
  function a(c) {
    i || (e.transform = n(r.direction(c)));
  }
  function u(c) {
    i = !c;
  }
  function f() {
    i || (e.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: f,
    to: a,
    toggleActive: u
  };
}
function Ks(r, t, n, e, i, o, s, a, u) {
  const l = Ne(i), c = Ne(i).reverse(), g = y().concat(R());
  function S(_, L) {
    return _.reduce((z, q) => z - i[q], L);
  }
  function v(_, L) {
    return _.reduce((z, q) => S(z, L) > 0 ? z.concat([q]) : z, []);
  }
  function p(_) {
    return o.map((L, z) => ({
      start: L - e[z] + 0.5 + _,
      end: L + t - 0.5 + _
    }));
  }
  function x(_, L, z) {
    const q = p(L);
    return _.map((G) => {
      const ee = z ? 0 : -n, ie = z ? n : 0, X = z ? "end" : "start", te = q[G][X];
      return {
        index: G,
        loopPoint: te,
        slideLocation: Ge(-1),
        translate: En(r, u[G]),
        target: () => a.get() > te ? ee : ie
      };
    });
  }
  function y() {
    const _ = s[0], L = v(c, _);
    return x(L, n, !1);
  }
  function R() {
    const _ = t - s[0] - 1, L = v(l, _);
    return x(L, -n, !0);
  }
  function P() {
    return g.every(({
      index: _
    }) => {
      const L = l.filter((z) => z !== _);
      return S(L, t) <= 0.1;
    });
  }
  function E() {
    g.forEach((_) => {
      const {
        target: L,
        translate: z,
        slideLocation: q
      } = _, G = L();
      G !== q.get() && (z.to(G), q.set(G));
    });
  }
  function m() {
    g.forEach((_) => _.translate.clear());
  }
  return {
    canLoop: P,
    clear: m,
    loop: E,
    loopPoints: g
  };
}
function Xs(r, t, n) {
  let e, i = !1;
  function o(u) {
    if (!n)
      return;
    function f(l) {
      for (const c of l)
        if (c.type === "childList") {
          u.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    e = new MutationObserver((l) => {
      i || (Qt(n) || n(u, l)) && f(l);
    }), e.observe(r, {
      childList: !0
    });
  }
  function s() {
    e && e.disconnect(), i = !0;
  }
  return {
    init: o,
    destroy: s
  };
}
function Qs(r, t, n, e) {
  const i = {};
  let o = null, s = null, a, u = !1;
  function f() {
    a = new IntersectionObserver((v) => {
      u || (v.forEach((p) => {
        const x = t.indexOf(p.target);
        i[x] = p;
      }), o = null, s = null, n.emit("slidesInView"));
    }, {
      root: r.parentElement,
      threshold: e
    }), t.forEach((v) => a.observe(v));
  }
  function l() {
    a && a.disconnect(), u = !0;
  }
  function c(v) {
    return De(i).reduce((p, x) => {
      const y = parseInt(x), {
        isIntersecting: R
      } = i[y];
      return (v && R || !v && !R) && p.push(y), p;
    }, []);
  }
  function g(v = !0) {
    if (v && o)
      return o;
    if (!v && s)
      return s;
    const p = c(v);
    return v && (o = p), v || (s = p), p;
  }
  return {
    init: f,
    destroy: l,
    get: g
  };
}
function Zs(r, t, n, e, i, o) {
  const {
    measureSize: s,
    startEdge: a,
    endEdge: u
  } = r, f = n[0] && i, l = v(), c = p(), g = n.map(s), S = x();
  function v() {
    if (!f)
      return 0;
    const R = n[0];
    return B(t[a] - R[a]);
  }
  function p() {
    if (!f)
      return 0;
    const R = o.getComputedStyle(se(e));
    return parseFloat(R.getPropertyValue(`margin-${u}`));
  }
  function x() {
    return n.map((R, P, E) => {
      const m = !P, F = er(E, P);
      return m ? g[P] + l : F ? g[P] + c : E[P + 1][a] - R[a];
    }).map(B);
  }
  return {
    slideSizes: g,
    slideSizesWithGaps: S,
    startGap: l,
    endGap: c
  };
}
function ea(r, t, n, e, i, o, s, a, u) {
  const {
    startEdge: f,
    endEdge: l,
    direction: c
  } = r, g = Xt(n);
  function S(y, R) {
    return Ne(y).filter((P) => P % R === 0).map((P) => y.slice(P, P + R));
  }
  function v(y) {
    return y.length ? Ne(y).reduce((R, P, E) => {
      const m = se(R) || 0, F = m === 0, _ = P === $e(y), L = i[f] - o[m][f], z = i[f] - o[P][l], q = !e && F ? c(s) : 0, G = !e && _ ? c(a) : 0, ee = B(z - G - (L + q));
      return E && ee > t + u && R.push(P), _ && R.push(y.length), R;
    }, []).map((R, P, E) => {
      const m = Math.max(E[P - 1] || 0);
      return y.slice(m, R);
    }) : [];
  }
  function p(y) {
    return g ? S(y, n) : v(y);
  }
  return {
    groupSlides: p
  };
}
function ta(r, t, n, e, i, o, s) {
  const {
    align: a,
    axis: u,
    direction: f,
    startIndex: l,
    loop: c,
    duration: g,
    dragFree: S,
    dragThreshold: v,
    inViewThreshold: p,
    slidesToScroll: x,
    skipSnaps: y,
    containScroll: R,
    watchResize: P,
    watchSlides: E,
    watchDrag: m
  } = o, F = 2, _ = Ds(), L = _.measure(t), z = n.map(_.measure), q = Is(u, f), G = q.measureSize(L), ee = Vs(G), ie = js(a, G), X = !c && !!R, te = c || !!R, {
    slideSizes: Q,
    slideSizesWithGaps: Z,
    startGap: re,
    endGap: ne
  } = Zs(q, L, z, n, te, i), b = ea(q, G, x, c, L, z, re, ne, F), {
    snaps: w,
    snapsAligned: I
  } = Gs(q, ie, L, z, b), A = -se(w) + se(Z), {
    snapsContained: k,
    scrollContainLimit: D
  } = zs(G, A, I, R, F), O = X ? k : I, {
    limit: T
  } = qs(A, O, c), C = wn($e(O), l, c), $ = C.clone(), j = Ne(n), V = ({
    dragHandler: ve,
    scrollBody: tt,
    scrollBounds: rt,
    options: {
      loop: Le
    }
  }) => {
    Le || rt.constrain(ve.pointerDown()), tt.seek();
  }, d = ({
    scrollBody: ve,
    translate: tt,
    location: rt,
    offsetLocation: Le,
    scrollLooper: Cn,
    slideLooper: An,
    dragHandler: kn,
    animation: jn,
    eventHandler: or,
    options: {
      loop: _n
    }
  }, In) => {
    const sr = ve.velocity(), ar = ve.settled();
    ar && !kn.pointerDown() && (jn.stop(), or.emit("settle")), ar || or.emit("scroll"), Le.set(rt.get() - sr + sr * In), _n && (Cn.loop(ve.direction()), An.loop()), tt.to(Le.get());
  }, N = _s(e, i, () => V(et), (ve) => d(et, ve)), J = 0.68, K = O[C.get()], ae = Ge(K), oe = Ge(K), ue = Ge(K), pe = Ls(ae, oe, ue, g, J), Qe = Bs(c, O, A, T, ue), Ze = Ys(N, C, $, pe, Qe, ue, s), rr = Ws(T), nr = Ve(), On = Qs(t, n, s, p), {
    slideRegistry: ir
  } = Js(X, R, O, D, b, j), Tn = Hs(r, n, ir, Ze, pe, nr), et = {
    ownerDocument: e,
    ownerWindow: i,
    eventHandler: s,
    containerRect: L,
    slideRects: z,
    animation: N,
    axis: q,
    dragHandler: Ms(q, r, e, i, ue, Ns(q, i), ae, N, Ze, pe, Qe, C, s, ee, S, v, y, J, m),
    eventStore: nr,
    percentOfView: ee,
    index: C,
    indexPrevious: $,
    limit: T,
    location: ae,
    offsetLocation: oe,
    options: o,
    resizeHandler: $s(t, s, i, n, q, P, _),
    scrollBody: pe,
    scrollBounds: Fs(T, oe, ue, pe, ee),
    scrollLooper: Us(A, T, oe, [ae, oe, ue]),
    scrollProgress: rr,
    scrollSnapList: O.map(rr.get),
    scrollSnaps: O,
    scrollTarget: Qe,
    scrollTo: Ze,
    slideLooper: Ks(q, G, A, Q, Z, w, O, oe, n),
    slideFocus: Tn,
    slidesHandler: Xs(t, s, E),
    slidesInView: On,
    slideIndexes: j,
    slideRegistry: ir,
    slidesToScroll: b,
    target: ue,
    translate: En(q, t)
  };
  return et;
}
function ra() {
  const r = {};
  let t;
  function n(u) {
    t = u;
  }
  function e(u) {
    return r[u] || [];
  }
  function i(u) {
    return e(u).forEach((f) => f(t, u)), a;
  }
  function o(u, f) {
    return r[u] = e(u).concat([f]), a;
  }
  function s(u, f) {
    return r[u] = e(u).filter((l) => l !== f), a;
  }
  const a = {
    init: n,
    emit: i,
    off: s,
    on: o
  };
  return a;
}
const na = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0
};
function ia(r) {
  function t(o, s) {
    return Rn(o, s || {});
  }
  function n(o) {
    const s = o.breakpoints || {}, a = De(s).filter((u) => r.matchMedia(u).matches).map((u) => s[u]).reduce((u, f) => t(u, f), {});
    return t(o, a);
  }
  function e(o) {
    return o.map((s) => De(s.breakpoints || {})).reduce((s, a) => s.concat(a), []).map(r.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: e
  };
}
function oa(r) {
  let t = [];
  function n(o, s) {
    return t = s.filter(({
      options: a
    }) => r.optionsAtMedia(a).active !== !1), t.forEach((a) => a.init(o, r)), s.reduce((a, u) => Object.assign(a, {
      [u.name]: u
    }), {});
  }
  function e() {
    t = t.filter((o) => o.destroy());
  }
  return {
    init: n,
    destroy: e
  };
}
function He(r, t, n) {
  const e = r.ownerDocument, i = e.defaultView, o = ia(i), s = oa(o), a = Ve(), u = ra(), {
    mergeOptions: f,
    optionsAtMedia: l,
    optionsMediaQueries: c
  } = o, {
    on: g,
    off: S,
    emit: v
  } = u, p = G;
  let x = !1, y, R = f(na, He.globalOptions), P = f(R), E = [], m, F, _;
  function L() {
    const {
      container: V,
      slides: d
    } = P;
    F = (Lt(V) ? r.querySelector(V) : V) || r.children[0];
    const J = Lt(d) ? F.querySelectorAll(d) : d;
    _ = [].slice.call(J || F.children);
  }
  function z(V) {
    const d = ta(r, F, _, e, i, V, u);
    if (V.loop && !d.slideLooper.canLoop()) {
      const N = Object.assign({}, V, {
        loop: !1
      });
      return z(N);
    }
    return d;
  }
  function q(V, d) {
    x || (R = f(R, V), P = l(R), E = d || E, L(), y = z(P), c([R, ...E.map(({
      options: N
    }) => N)]).forEach((N) => a.add(N, "change", G)), P.active && (y.translate.to(y.location.get()), y.animation.init(), y.slidesInView.init(), y.slideFocus.init(), y.eventHandler.init(j), y.resizeHandler.init(j), y.slidesHandler.init(j), y.options.loop && y.slideLooper.loop(), F.offsetParent && _.length && y.dragHandler.init(j), m = s.init(j, E)));
  }
  function G(V, d) {
    const N = w();
    ee(), q(f({
      startIndex: N
    }, V), d), u.emit("reInit");
  }
  function ee() {
    y.dragHandler.destroy(), y.eventStore.clear(), y.translate.clear(), y.slideLooper.clear(), y.resizeHandler.destroy(), y.slidesHandler.destroy(), y.slidesInView.destroy(), y.animation.destroy(), s.destroy(), a.clear();
  }
  function ie() {
    x || (x = !0, a.clear(), ee(), u.emit("destroy"));
  }
  function X(V, d, N) {
    !P.active || x || (y.scrollBody.useBaseFriction().useDuration(d === !0 ? 0 : P.duration), y.scrollTo.index(V, N || 0));
  }
  function te(V) {
    const d = y.index.add(1).get();
    X(d, V, -1);
  }
  function Q(V) {
    const d = y.index.add(-1).get();
    X(d, V, 1);
  }
  function Z() {
    return y.index.add(1).get() !== w();
  }
  function re() {
    return y.index.add(-1).get() !== w();
  }
  function ne() {
    return y.scrollSnapList;
  }
  function b() {
    return y.scrollProgress.get(y.location.get());
  }
  function w() {
    return y.index.get();
  }
  function I() {
    return y.indexPrevious.get();
  }
  function A() {
    return y.slidesInView.get();
  }
  function k() {
    return y.slidesInView.get(!1);
  }
  function D() {
    return m;
  }
  function O() {
    return y;
  }
  function T() {
    return r;
  }
  function C() {
    return F;
  }
  function $() {
    return _;
  }
  const j = {
    canScrollNext: Z,
    canScrollPrev: re,
    containerNode: C,
    internalEngine: O,
    destroy: ie,
    off: S,
    on: g,
    emit: v,
    plugins: D,
    previousScrollSnap: I,
    reInit: p,
    rootNode: T,
    scrollNext: te,
    scrollPrev: Q,
    scrollProgress: b,
    scrollSnapList: ne,
    scrollTo: X,
    selectedScrollSnap: w,
    slideNodes: $,
    slidesInView: A,
    slidesNotInView: k
  };
  return q(t, n), setTimeout(() => u.emit("init"), 0), j;
}
He.globalOptions = void 0;
function tr(r = {}, t = []) {
  const n = Pt(r), e = Pt(t), [i, o] = cr(), [s, a] = cr(), u = Nn(() => {
    i && i.reInit(n.current, e.current);
  }, [i]);
  return Pe(() => {
    if (Cs() && s) {
      He.globalOptions = tr.globalOptions;
      const f = He(s, n.current, e.current);
      return o(f), () => f.destroy();
    } else
      o(void 0);
  }, [s, o]), Pe(() => {
    Kt(n.current, r) || (n.current = r, u());
  }, [r, u]), Pe(() => {
    As(e.current, t) || (e.current = t, u());
  }, [t, u]), [a, i];
}
tr.globalOptions = void 0;
const Br = (r) => r != null, sa = Es(() => ({
  hideOverflow: {
    overflow: "hidden"
  },
  itemContainer: {
    backfaceVisibility: "hidden",
    display: "flex",
    touchAction: "pan-y",
    marginLeft: ({ gap: r }) => `calc(${r} * -1)`
  },
  item: {
    flexGrow: 0,
    flexShrink: 0,
    minWidth: 0,
    paddingLeft: ({ gap: r }) => r
  }
})), fa = ({
  items: r,
  isSmall: t,
  allowOverflow: n = !1,
  gap: e = "1rem",
  scrollTo: i,
  children: o,
  ...s
}) => {
  const [a, u] = tr(s), f = sa({ gap: e }), l = wt(() => {
    const c = r;
    if (t && c.length === 2)
      c.splice(1, 0, null);
    else {
      const g = c.findIndex((S) => S === null);
      g !== -1 && c.splice(g, 1);
    }
    return c;
  }, [r, t]);
  return Pe(() => {
    Br(u) && Br(i) && u.scrollTo(i.index, i.jump);
  }, [u, i]), /* @__PURE__ */ nt(
    "div",
    {
      className: qr(!n && f.hideOverflow),
      ref: a,
      children: /* @__PURE__ */ nt("div", { className: f.itemContainer, children: l.map((c, g) => /* @__PURE__ */ nt(
        "div",
        {
          className: qr(f.item),
          onClick: () => u == null ? void 0 : u.scrollTo(g),
          children: c && (o == null ? void 0 : o({
            index: g,
            item: c,
            isSelected: (u == null ? void 0 : u.selectedScrollSnap()) === g
          }))
        },
        g
      )) })
    }
  );
};
export {
  fa as Carousel
};
